import { ValidStates } from './ProviderConsts'

const HospitalsAffiliations = {
  [ValidStates.OH]: [
    'A G Holley State Hospital',
    'Adams County Hospital',
    'Adams County Regional Medical Center',
    'Adena Health System',
    'Adena Medical Center',
    'Adena Regional Medical Center',
    'Advanced Specialty Hospital',
    'Affinity Medical Center',
    'AGMC',
    'Ahuja Medical Center',
    'Akron Childrens Hospital',
    "Akron Children's Hospital Mahoning Valley",
    'Akron City Hospital',
    'Akron General Medical Center',
    'AKRON GENERAL MEDICAL CNETER',
    'Akrons Childrens Hospital',
    'Albany Medical Center Hospital',
    'Allegheny University of the Health Sciences',
    'Allen Medical Center',
    'Alliance Community Hospital',
    'Amherst Hospital',
    'Arthur G. James Cancer Hospital',
    'Atrium Medical Center',
    'Aultman Hospital',
    'Aultman Orrville Hospital',
    'Avita Ontario Hospital',
    'Banner Heart Hospital',
    'Barnesville Hospital Association',
    'Bay Park Community Hospital',
    'Beacon Ambulatory Surgery Center-Summit',
    'Becket Springs Hospital',
    'Belmont Community Hospital',
    'Berger Health System',
    'Bethesda North Hospital',
    'Blanchard Valley Health System',
    'Blanchard Valley Health System - Blanchard Valley Hospital',
    'Blanchard Valley Hospital',
    'Blessing Hospital',
    'Bon Secours Hospital',
    "Brigham and Women's Hospital",
    'Brown County General Hospital',
    'Bucyrus Community Hospital',
    'Butler County Sleep Center',
    'Cabell Huntington Hospital',
    'Camden Clark Medical Center',
    'Camden-Clark Memorial Hospital',
    'Canton-Potsdam Hospital',
    "Children's Hosp Medical Center",
    'CHILDRENS HOSPITAL',
    "Children's Hospital",
    "Children's Hospital (Cincinnati",
    "Children's Hospital (Columbus OH)",
    "Children's Hospital of Pittsburgh of UPMC",
    "Children's Medical Center (Dayton",
    'Christ Hospital',
    'Christ Hospital (Cincinnati)',
    'Christiana Care Health Services',
    'Cincinnati Childrens Hospital Medical Center',
    'Cleveland Clinic',
    'Cleveland Clinic - Weston',
    'Cleveland Clinic Akron General',
    "Cleveland Clinic Children's Hospital for Rehabilitation",
    'Cleveland Clinic Union Hospital',
    'CMH Regional Health System',
    'Colleton Regional Hospital',
    'Columbus Community Hospital (Columbus OH)',
    'Columbus Dublin Springs',
    'Columbus Springs East Hospital',
    'Community Health Partners',
    'Community Hospitals & Wellness Centers',
    'Conemaugh Nason Medical Center',
    'Coshocton County Memorial Hospital',
    'Coshocton Hospital Ortho Clinic',
    'Coshocton Regional Medical Center',
    'David Grant Medical Center',
    "Dayton Children's Hospital",
    'Dayton Heart Hospital',
    'Deaconess Hospital',
    'Doctors Hospital',
    'Doctors Hospital (Columbus)',
    'Doctors Hospital West (Columbus)',
    'DrakeCenter',
    'Dublin Methodist Hospital',
    'Dublin Springs',
    'Dunlap Memorial Hospital',
    'EASR OHIO REGIONAL HOSPITAL',
    'East Liverpool City Hospital',
    'East Ohio Hospital LLC',
    'East Ohio Regional Hospital',
    'EAST OHIO REGIONAL HOSPTIAL',
    'Elyria Memorial Hospital',
    'Elyria Regional Medical Center',
    'EMH Regional Medical Center',
    'Fairfield Medical Center',
    'Fairview Hospital',
    'Fayette County Memorial Hospital',
    'Firelands Community Hospital',
    'Flower Hospital-Family Medicine',
    'Forbes Hospital',
    'Fort Hamilton Hospital',
    'Fulton County Health Center',
    'GENESIS HEALTH CARE',
    'Genesis HealthCare System',
    'Genesis HealthCare System (Zanesville)',
    'Genesis Healthcare Systems - Bethesda',
    'Good Samaritan Hospital',
    'Grady Memorial',
    'Grady Memorial Hospital',
    'Grant Hospital',
    'Grant Medical Center',
    'Grant/Riverside Methodist Hosp (Columbus',
    'Greene Memorial Hospital',
    'Hardin Memorial Hospital',
    'Harrison Community Hospital (Cadiz)',
    'Henry County Hospital',
    'Henry Ford Hospital',
    'Heritage Valley Health System',
    'Herrick Memorial Hospital',
    'Highland District Hospital',
    'Hillcrest Hospital',
    'Hocking Valley Community Hospital',
    'Holy Cross Hospital',
    'Holzer Medical Center',
    'Hospital for Sick Children',
    'Institute for Orthopaedic Surgery',
    'James Cancer Hospital and Solove Research Institute',
    'Joint Township District Memorial Hosp',
    'Karmanos Cancer Institute',
    'Kettering Medical Center',
    'Kindred Hospital',
    "King's Daughters' Health",
    'Kings Daughters Medical Center Ohio',
    'Lake Hospital System',
    'Lakewood Hospital',
    'Lexington Medical Center',
    'Licking Memorial Hospital',
    'Lima Memorial Hospital',
    'Lodi Community Hospital',
    'Lurie Childrens Hospital',
    'Madison County Hospital',
    'Magruder Hospital',
    'Marietta Memorial Hospital',
    'Marion General Hospital',
    'Mary Rutan Hospital',
    'Marymount Hospital',
    'McCullough-Hyde Memorial Hospital/TriHealth',
    'McLaren Regional Medical Center',
    'Meadows of Ottawa',
    'Medical University of South Carolina',
    'Medina Hospital',
    'Memorial Hospital (Marysville OH)',
    'Mercy - St Anne Hospital',
    'Mercy Anderson',
    'Mercy Health -  St. Charles Hospital',
    'Mercy Health - Allen Hospital',
    'Mercy Health - Anderson Hospital',
    'Mercy Health - Clermont Hospital',
    'Mercy Health - Defiance Hospital',
    'Mercy Health - Fairfield Hospital',
    'Mercy Health - Jewish Hospital',
    'Mercy Health - Kings Mills Hospital',
    'Mercy Health - Lorain Hospital',
    'Mercy Health - Marcum & Wallace Hospital',
    'Mercy Health - Regional Medical Center',
    'Mercy Health - Springfield Regional Medical Center',
    'Mercy Health - St Charles Hospital',
    'Mercy Health  St Elizabeth Youngstown Hospital',
    'Mercy Health - St Joseph Warren Hospital',
    "Mercy Health - St Rita's Medical Center",
    'Mercy Health - St Vincent Medical Center',
    'Mercy Health - St. Anne Hospital',
    'Mercy Health - St. Charles Hospital',
    'Mercy Health - St. Elizabeth Boardman Hospital',
    'Mercy Health - St. Elizabeth Youngstown Hospital',
    'Mercy Health - St. Joseph Warren Hospital',
    "Mercy Health - St. Rita's Medical Center",
    'Mercy Health - St. Vincent Medical Center',
    'Mercy Health - Tiffin Hospital',
    'Mercy Health - West Hospital',
    'Mercy Health - Willard Hospital',
    'Mercy Health Allen Hospital',
    'Mercy Health Anderson Hospital',
    "Mercy Health Children's Hospital",
    'Mercy Health Clermont Hospital',
    'Mercy Health Defiance Clinic',
    'Mercy Health Defiance Hospital',
    'Mercy Health Fairfield Hospital',
    'Mercy Health Perrysburg Hospital',
    'Mercy Health Physicians Youngstown LLC',
    'Mercy Health St Anne Hospital',
    'Mercy Health St Charles Hospital',
    'Mercy Health St Elizabeth Boardman Hospital',
    'Mercy Health St Elizabeth Youngstown Hospital',
    'Mercy Health St Joseph Warren Hospital',
    "Mercy Health St Rita's Medical Center",
    'Mercy Health St Vincent Medical Center',
    'Mercy Health- St. Vincent Medical Center',
    'Mercy Health Tiffin Hospital',
    'Mercy Health Urbana Hospital',
    'Mercy Health West',
    'Mercy Health West Hospital',
    'Mercy Health Willard Hospital',
    'Mercy Hospital Anderson',
    'Mercy Hospital Clermont',
    'Mercy Medical Center',
    'Mercy Medical Center (Canton',
    'Mercy Medical Center (Canton OH)',
    'Mercy Medical Center (Rockville Centre',
    'Mercy Medical Center (Springfield OH)',
    'Mercy Memorial Hospital',
    'Mercy Regional Medical Center',
    'MetroHealth Medical Center',
    'Miami Valley Hospital',
    'Mon Health Medical Center',
    'Mount Carmel',
    'Mount Carmel East',
    'Mount Carmel East Hospital',
    'Mount Carmel Grove City',
    'Mount Carmel Health',
    'Mount Carmel Health Partners',
    'Mount Carmel Medical Center',
    'Mount Carmel New Albany Surgical Hospital',
    "Mount Carmel Saint Ann's",
    "Mount Carmel St. Ann's",
    'Mount Carmel West',
    'Mt. Carmel Health Systems',
    "Nationwide Children's Hospital",
    'New Albany Surgical Hospital',
    'Northside Hospital',
    "Norton Women's and Children's Hospital",
    "O'Bleness Memorial Hospital",
    'Ohio Health Practices',
    'Ohio State Univ Medical Center',
    'Ohio State University Hospital',
    'Ohio State University Wexner Medical Center',
    'Ohio Valley Medical Center',
    'OhioHealth Berger Hospital',
    'OhioHealth Dublin Methodist Hospital',
    'OhioHealth Grant Medical Center',
    'OhioHealth Marion General Hospital',
    'OhioHealth MedCentral Mansfield Hospital',
    'OhioHealth Riverside Methodist Hospital',
    'Omaha Childrens Hospital',
    'OSU Medical Center/Columbus Childrens Hospital',
    'OSU Wexner Medical Center',
    'OSUWMC',
    'Overlook Hospital',
    'Paoli Memorial Hospital',
    'Penn State Univ Hosp',
    'Physicians Outpatient Surgery Center Ltd.',
    'Polaris Surgery Center',
    'Promedica Toledo Hospital',
    'Regions Hospital',
    'Reynolds Memorial Hospital',
    'Riverside Grant',
    'Riverside Methodist Hospital',
    'Selby General Hospital',
    'Sistersville General Hospital',
    'Soin Medical Center',
    'South Pointe Hospital',
    'Southeastern Ohio Reg Med Ctr',
    'SOUTHEASTERN OHIO REGIOHNAL MEDICAL CENTER',
    'Southeastern Ohio Regional Med Ctr',
    'SOUTHEASTERN OHIO REGIONAL MEDICAL CENTER',
    'Southern Ohio Medical Center',
    'Springfield Regional Medical Center',
    "St Ann's Hospital",
    'St Elizabeth Boardman Health Center',
    "St Joseph's Hospital (Parkersburg",
    "St Luke's Hospital",
    'St Marys Regional Medical Center',
    "St Rita's Medical Center",
    'St Vincent Charity Hospital (Cleveland OH)',
    "St. Ann's Hospital",
    'St. Elizabeth Edgewood',
    'St. Elizabeth Health Center',
    "St. Rita's Medical Center",
    'State University of New York',
    'Summa Barberton Citizens Hospital',
    'Summa Health System',
    'Sycamore  Medical Center',
    'The Cleveland Clinic Foundation',
    'The Jewish Hospital - Mercy Health',
    'The Toledo Hospital',
    'Tidelands Waccamaw Community Hospital',
    'Trihealth Evendale Hospital',
    'Trinity Hospital Twin City',
    'Tripler Army Medical Center',
    'UH Geauga Medical Center',
    'Union Hospital (Dover OH)',
    'University Hospitals of Cleveland',
    'University of Alabama at Birmingham Medical Center',
    'University of Cincinnati Hospital',
    'University of Cincinnati Medical Center',
    'University of Kansas Hospital',
    'University of Louisville Hospital',
    'UPMC Magee-Womens Hospital',
    'USAF Med Ctr Wright-Patterson',
    'Veterans Affairs Med Center',
    'West Chester Hospital',
    'West Virginia University Hospitals',
    'Wheeling Hospital',
    'WHEELING MEDICAL HOSPITAL',
    'Wilcox Memorial Hospital',
    'Wooster Community Hospital',
    'Yale-New Haven Hospital',
    'Good Samaritan Hospital Cincinnati',
    'Cleveland Clinic Mercy Hospital',
    'Edwin Shaw',
    'Euclid Hospital',
    'Lutheran Hospital',
    'Medina General Hospital',
    'Cleveland Clinic Foundation (Cleveland)',
    'Columbia Memorial Hospital',
    'Ashtabula County Medical Center',
    'Kettering Med Center-Network',
    'Kingman Regional Medical Center',
    'Abrazos Arizona Heart Hospital',
    'Harrison Community Hospital',
    'Beacon Ambulatory Surgery Center-West',
    'Jt Township Dist Mem Hospital',
    'Blanchard Valley Health System - Bluffton Hospital',
    'Wood County Hospital',
    'Faulkner Hospital',
    'MedCentral Health System',
    'SELBY CENERAL HOSPITAL',
    'Massena Memorial Hospital',
    'Summa Health System Barberton Hospital',
    'Clinton Memorial Hospital',
    'Community Hospitals and Wellness Centers',
    'Chenango Memorial Hospital',
    'Wyandot Memorial Hospital',
    'Mansfield Hospital',
    'Barnesville Hospital',
    "Children's Hospital (Columbus)",
    'River View Surgery Center',
    'RIVERVIEW SURGERY CENTER',
    'West Penn Hospital',
    'McLaren Central Michigan',
    'Zanesville Surgery Center',
    'Mercy Franciscan Hospital - WH',
    'Licking Memorial Health Sysytems',
    'Davita Dialysis',
    'Bethesda Hospital (Zanesville',
    'Medical Center of Newark',
    'Mount Carmel Medical Center (Columbus',
    'New Albany Surgical Center',
    'Marietta Surgery Center',
    "Children's Hospital Medical Center",
    'Deaconess Hospital (Cincinnati',
    'TriHealth Bethesda North Hospital',
    'Baptist Health Hopkinsville',
    'Mercy Health - Lourdes Hospital',
    'St. John Westshore Hospital',
    'Kettering Health Network Troy Hospital',
    'Louis A Weiss Memorial Hospital',
    'Mercy Health - Urbana Hospital',
    'Trumbull Memorial Hospital',
    'Riverview Regional Medical Center',
    "Toledo Children's Hospital",
    'William Beaumont Hospital',
    'Promedica Flower Hospital',
    'Covenant Healthcare Michigan',
    "Promedica Toledo Children's Hospital",
    'Triumph Hospital',
    'St Charles Mercy Hospital (Oregon',
    'Galion Hospital',
    'Bethesda Ambulatory Surgery Center',
    'Jewish Hospital',
    'Promedica Bay Park Hospital',
    'Salem Community Hospital',
    'Salem Hospital',
    'The Surgical Hospital At Southwoods',
    'OhioHealth Doctors Hospital',
    'Van Wert County Hospital',
    "Mt Carmel St Ann's",
    'ST ANNS HOSPITAL',
    'Mount Carmel Health System (Columbus',
    'Mt Carmel New Albany Surgical Hospital',
    'OhioHealth Grady Memorial Hospital',
    'Mount Carmel St. Anns',
    'UofL Health - UofL Hospital',
    'Fairmont Regional Medical Center',
    'OBLENESS MEMORIAL HOSPITAL',
    'Ohio State University Medical Center',
    'TriPoint Medical Center',
    'Bryn Mawr Hospital',
    'Mercy Health - Defiance Clinic',
    'Miami Valley Hospital South',
    "Children's Hospital Medical Center of Akron",
    'Cleveland Clinic Avon Hospital',
    'Cleveland Clinic Fairview Hospital',
    'Cleveland Clinic Rehabilitation Hospital-Avon',
    'HIllcrest Hiospital',
    'Meridia Hillcrest Hospital',
    'UPMC McKeesport Hospital',
    'Avon Hospital',
    'The  Christ Hospital',
    'Allen Memorial Hospital',
    'Appalachian Behavioral Healthcare',
    'Good Samaritan Medical Center',
    'Select Specialty Hospital~Zanesville',
    'Hillebrand Nursing & Rehabilitation Ctr.',
    'Joel Pomerene Mem Hospital',
    'Tuscarawas Ambulatory Surgery Center'
  ],
  [ValidStates.AZ]: [
    'Abrazo Arrowhead Campus',
    'Abrazo Central Campus (formerly Phoenix Baptist)',
    'Abrazo Maryvale Campus (Previously Maryvale)',
    'Abrazo Scottsdale Campus',
    'Abrazo West Campus',
    'Arizona Orthopedic Surgical Hospital',
    'Banner Baywood Medical Center',
    'Banner Boswell Medical Center',
    'Banner Casa Grande Regional Medical Center',
    'Banner Del E Webb Medical Center',
    'Banner Desert Medical Center',
    'Banner Estrella Medical Center',
    'Banner Gateway Medical Center',
    'Banner Heart Hospital',
    'Banner Ironwood Medical Center',
    'Banner Ocotillo Medical Center',
    'Banner Surgery Center',
    'Banner Surgery Centers',
    'Banner Thunderbird Medical Center',
    'Banner University Medical Center - Tucson Campus',
    'Banner University Medical Center PHX',
    'Carl T Hayden Veterans Affairs Medical Center',
    "Carondelet St. Joseph's Hospital - Tucson",
    'Chandler Regional Medical Center',
    'Desert Vista Hospital',
    'District Medical Group',
    'Honor Health Deer Valley',
    'Honor Health North Mountain',
    'Honor Health Osborn',
    'Honor Health Shea',
    'Kindred Hospital AZ',
    'Maricopa Medical Center',
    'Mercy Gilbert Medical Center',
    'Mountain Vista Medical Center',
    'Oro Valley Hospital',
    "Phoenix Children's Hospital",
    'Phoenix Eye Surgery Center',
    'Physicians Surgery Center of Tempe',
    'San Tan Surgery Center',
    "St. Joseph's Hospital & Medical Center",
    "Tempe St. Luke's Hospital",
    'The Surgical Hospital of Phoenix',
    'Tucson Medical Center',
    'Tucson Medical Center, Carondelet St Josephs Hospital',
    'Verde Valley Medical Center',
    'Warner Medical Park Outpatient Surgery',
    'Warner Park Outpatient Surgery Center'
  ]
}

const MedicalGroupsAffiliations = {
  [ValidStates.OH]: [
    'American Health Network - Westerville',
    'Mercy Health - Howland Plastic and Reconstructive Surgery',
    'Mercy Health - St Charles Neonatology',
    'Mercy Health - St Vincent Neonatology',
    'Mercy Health - Sylvania Pain Medicine',
    'MSA Primary Care',
    "Nationwide Children's Hospital",
    'OSU Internal Medicine LLC',
    'Pediatric Academic Association',
    'The Cleveland Clinic Foundation',
    'Mercy Health Psych - Perrysburg Primary Care',
    'Wheeling Hospital Inc',
    'Cleveland Clinic Akron General Ear Nose and Throat',
    'Central Ohio Primary Care Physicians Inc',
    'Mercy Health - St Elizabeth Youngstown Medical Oncology',
    'Mercy Health - St Elizabeth Youngstown Breast Care Surgery',
    'Mercy Health - Joanie Abdu Breast Care Columbiana',
    'Akron Childrens Hospital',
    'ACHP-Fairlawn',
    "Children's Hospital Center of Akron - ACHP Fairlawn",
    'Mount Carmel Health System Physicians',
    'Allied Dermatology and Skin Surgery LLC',
    'Genesis Medical Group LLC',
    'Mercy Health - Defiance Clinic Urology',
    'Mercy Health - St Vincent Specialty Clinic',
    'Mercy Health - St Charles Urology Center',
    'Mercy Health - Tiffin Hospital Pediatric Locums',
    'Ophthalmic Surgeons & Consultants of Ohio Inc',
    'KINGS DAUGHTERS HEALTH',
    'Jones-Wood Psychological',
    'Family Allergy & Asthma',
    'MedOne Hospital Physicians',
    'OSU Psychiatry LLC',
    'Mercy Health - St Vincent Trauma Surgeons',
    'Mercy Health - St Vincent General and Trauma Surgery',
    'Mercy Health - St Charles General Surgery',
    "Cleveland Clinic Akron General Women's Health Center",
    'Holzer Clinic LLC - Physical Medicine & Rehabilitation',
    'OSU Eye Physicians & Surgeons LLC',
    'Mercy Health - Heart and Vascular Institute Oberlin',
    'Mercy Health - Lorain Heart Failure Clinic',
    'Mercy Health - Heart and Vascular Institute Lorain',
    'Mercy Health - Heart and Vascular Institute Sheffield',
    'Ohio State University Wexner Medical Center',
    'Ohio Gastroenterology Group Inc',
    'Mercy Health - Columbiana Primary Care',
    'Mercy Health - Columbiana Walk-In Care',
    'Mercy Health - Boardman Primary Care',
    'Lower Lights Christian Health Center',
    'Wooster Clinic LLC',
    'Mercy Health - St Vincent H&P Services',
    'Orthopaedic Specialists & Sports Medicine Ltd',
    'OSU East Physician Services',
    'Licking Memorial Pulmonology',
    'Aultman Division of Medical Education',
    'Aultman General Surgery',
    'Aultman Orrville Hospital',
    'PrimaryOne Health',
    'Mount Carmel Pulmonary & Sleep',
    'Mid-Ohio Behavioral Health LLC',
    'Restorative Pathways Counseling LLC',
    'Hopewell Health Centers Inc',
    'OSU Otolaryngology Head and Neck Surgery',
    'Marietta Memorial Hospital',
    'Marietta Memorial Hosptial',
    "Children's Surgical Associates Corporation",
    "Children's Hospital Center of Akron- ACHP- Austintown",
    'Mercy Health - Youngstown Hospitalists',
    'Mercy Health - Warren Hospitalists',
    'Mercy Health - Boardman Hospitalists',
    'ACHP-Ellet',
    'ACHP Campbell',
    'OSU Otolaryngology Head and Neck Surgery LLC',
    'Center For Surgical Dermatology Inc',
    'Mercy Health - LaGrange Primary Care',
    'Mercy Health - Vermilion Walk-In Care',
    'Mercy Health - Oberlin Primary Care',
    'Mercy Health - Oberlin Walk-In Care',
    'Mercy Health - Lorain Walk-In Care',
    'Mercy Health - Sheffield Walk-In Care',
    'Mercy Health - Oak Point Walk-in Care',
    'Mercy Health - Wellington Walk-In Care',
    'Boulder Care Provider Group PA',
    'Mercy Health - Perrysburg Gastroenterology',
    'Mercy Health - St Vincent Gastroenterology',
    'Mercy Health - GI Hospitalists',
    'Mercy Health - Oregon Gastroenterology',
    'Mercy Health - Westfield Gastroenterology',
    'St Marys Express Care',
    'Cleveland Clinic Akron General Emergency Medicine',
    'OSU General Internal Medicine LLC',
    'OSU Harding Behavioral Health Physicians',
    'Mercy Health - Defiance Clinic Orthopedics',
    'Aultman Medical Group Canton Urology',
    'ACH Neonatal Subintensive Care-NICU',
    'JIS Physical Therapy',
    'ViaQuest Psychiatric & Behavioral Solutions',
    'Holzer Clinic LLC - Family Medicine',
    "Nationwide Children's Hospital Neonatology Clinic",
    'Holzer Clinic LLC - Hematology/Oncology',
    'Faifield Healthcare Professionals Hematology & Oncology',
    'Mary Rutan Occupational Medicine',
    'Mary Rutan Urgent Care',
    'NEX Associate and Family Clinic',
    'Mary Rutan Urbana Clinic',
    'Joint Implant Surgeons',
    'Pars Neurosurgical Associates Inc',
    'Beacon Orthopaedics & Sports Medicine Ltd',
    'Beacon Orthopaedics & Sports Medicine',
    'Maier Psychological Services',
    'Glorioso General Practice Inc',
    'Mercy Health - Youngstown Neurohospitalist',
    'Mercy Health - The Neuroscience Institute Toledo',
    'Mercy Health - Lorain Neurology',
    'Mercy Health - The Heart and Vascular Institute Ygst Card',
    'Mercy Health - The Heart and Vascular Institute East Liverp',
    'Mercy Health - The Heart and Vascular Institute Warren Card',
    'Mercy Health - The Heart and Vascular Institute Poland Card',
    'Cardiovascular Consultants',
    'Aultman Deuble Heart & Vascular Hospital LLC',
    'Aultman Orrville Dunlap Family Physicians',
    'Regional Cardiac Arrhythmia Inc',
    'Polaris Neighborhood Chiropractic',
    'American Health Network - Hilltop',
    'Aultman Hospital',
    'Aultman Orrville Doylestown Health Center',
    'Tuscarawas Health Center of Aultman Orrville Hospital',
    'OSU Internal  Medicine LLC',
    'Aultman Family Medicine - Waynesburg',
    'Mary Rutan Hospital',
    'Mercy Health - Fairfield Internal Medicine',
    'Dermatologists of Greater Columbus',
    'OhioDerm Holding Inc',
    'OSU Urology LLC',
    'Holzer Clinic LLC - Hospitalist',
    'OSU Internal Medicine Stoneridge',
    'Cleveland Clinic Akron General Hand Surgery',
    'Cleveland Clinic Akron General Orthopedics',
    'Orthopedic One Inc',
    "Nationwide Children's Hospital Urgent Care Main Campus",
    "Nationwide Children's Hospital Primary Care Center - Downtown",
    "Akron General Women's Health Clinic/OB Triage",
    'OSUP Community Outreach LLC',
    'Muskingum Valley Health Centers',
    'Madison Family Health Corporation',
    'General Medical Consultants',
    'Mercy Health - St Elizabeth Youngstown Orthopedics',
    'Genesis Urogynecology',
    'EORH Physician Group',
    'EORH Physcian Group',
    'Clinic Medical Services LLC',
    'Mercy Health Urgent Care',
    'OSU Physical Medicine & Rebahilitation LLC',
    'OSU Physical Medicine & Rehabilitation LLC',
    'Aultman North Canton Medical Group',
    'AMG Canton Urology',
    'Mercy Health - Forest Hills Family Medicine',
    'CEP America - Ohio LLC',
    'Central Ohio Surgical Associates Inc',
    'Cleveland Clinic Akron General Maternal Fetal Medicine',
    'Orthopedic Foot and Ankle Center',
    'Mount Carmel Medical Group Big Run',
    'OSU Surgery LLC',
    'JOBETH ROLLANDINI DPM LLC',
    'OrthoNeuro',
    'Blue Sky Counseling Services dba Kaolene Metzger',
    'Wedgewood Urgent Care LLC',
    'Ohio ENT & Allergy Physicians',
    'Amy Brenner MD & Associates LLC',
    'Mercy Health - Westfield Obstetrics and Gynecology',
    'Mercy Health - Sylvania Obstetrics and Gynecology',
    'Mercy Health - Spring Valley Obstetrics and Gynecology',
    'Mercy Health-Youngstown Pulmonary Health and Research Center',
    'Mercy Health - Lung Nodule Center',
    'Mercy Health - St Joseph Warren Hospital Medical Intensive Care',
    'Mercy Health - Mercy Crest Gastroenterology',
    'ACHP - Outpatient Therapy',
    "Children's Hospital Center of Akron- Plastic Surgery",
    'ACHP - School Health Services',
    'At Your Door Visiting Healthcare Services LLC',
    'Cleveland Clinic Akron General Anesthesia',
    'Mercy Health - Delphos Urgent Care',
    'Mercy Health - Westside Urgent Care',
    'Ohio Specialty Physicians Corporation',
    'Cleveland Clinic Akron General Family Medicine',
    'OSU Radiation Oncology LLC',
    'Central Ohio Counseling Services',
    'OSU Neuroscience Center LLC',
    'James B Feibel Center',
    'Mercy Health - Howland Walk-In Care',
    'Mercy Health - Wick Walk-In Care at YSU',
    'Mercy Health - SJWH Weight Loss Center',
    'Mercy Health - Church Hill Walk-In Care',
    'Mercy Health - Austintown Walk-In Care',
    'Mercy Health - Salem Walk-In Care',
    'Mercy Health - Sebring Walk-In Care',
    'Mercy Health - North Lima Walk-In Care',
    'Mount Carmel Neurosurgery',
    'Cleveland Clinic Akron General Primary Care',
    'Mount Carmel Occupational Health',
    'Mount Carmel Occupational Health Clinic',
    'ACHP Belpre',
    'Mercy Health - Perrysburg Obstetrics and Gynecology',
    'Cleveland Clinic Akron General Spine and Pain',
    "Nationwide Children's NICU at Grant Medical Center",
    'ACP Ashland West',
    'ACHP - Ontario',
    'Hope419',
    'Mercy Health - Oberlin Pulmonology',
    'Mercy Health - Lorain Pulmonology',
    'Parkersburg Family Care Westbrook',
    'Parkersburg Family Care',
    'Wirt County Family Care',
    'Ripley Family Care',
    'Jackson County Schools Wellness Center',
    'River Valley Family Care',
    'Columbus OB/GYN Inc',
    'Cleveland Clinic Union Hospital Cardiology',
    'Radiology Inc',
    'Central Ohio Urology Group LLC',
    'Mercy Health - Perrysburg Orthopedics & Sports Medicine',
    'Mercy Health - Maumee Bay Orthopaedics and Sports Medicine',
    'Mercy Health-West Sylvania Orthopaedics and Sports Medicine',
    'Holzer Clinic LLC - Otolaryngology',
    'OSU GYN and OB Consultants LLC',
    'Mount Carmel Heart & Vascular Specialists',
    'Jacqueline A Thompson',
    'Muskingum Valley Oral Surgery',
    'Mercy Health - Kenwood Concierge',
    'Thornville Family Medical Center',
    "Nationwide Children's Hospital Nephrology Clinic",
    'Comprehensive Eye Care of Central Ohio Inc',
    'Wellington Ortho and Sports Med Eastgate',
    'Hocking Valley Medical Group Inc',
    'Fairfield Healthcare Professionals Urology',
    'Orthopaedic Institute of Dayton',
    'Mercy Health - Pulmonary and Critical Care Kenwood',
    'Mercy Health - Kings Mills Pulmonology and Critical Care',
    'Licking Memorial Family Practice',
    'Licking Memorial Family Practice Johnstown',
    'Licking Memorial Family Practice-East',
    'Reproductive Gynecology Inc',
    'Medical Associates of Cambridge',
    'Mercy Health - Anderson Family Medicine',
    'Mercy Health - St Vincent Medical Center Pediatric Dept',
    'Mercy Health - Mason Primary Care',
    'Mercy Health - Infectious Disease Kenwood',
    'Arbor View Family Medicine Inc',
    "Children's Hospital Center of Akron- ENT",
    'Mercy Health - Amherst Obstetrics and Gynecology',
    'Mercy Health - The Heart Institute West',
    'Centerburg Chiropractic Center LLC',
    'ACH - RBHC Canton',
    'Cleveland Clinic Akron General Arthritis and Rheumatology',
    'Mercy Health - Virtualist Primary Care',
    'Mercy Health - Sheffield Pain Management',
    "Children's Hospital Center of Akron - Allergy & Immunology",
    "Children's Hospital Center of Akron- Allergy & Immunology",
    'ACHP - Allergy & Immunology',
    'Aultman Medical Group Endocrinology',
    'Ohio Physician Professional Corporation dba Aultman Endocrinology',
    "Nationwide Children's Hospital Hematology/Oncology Clinic",
    'Mercy Health - Harrison Pulmonary Sleep and Critical Care',
    'Mercy Health - West Pulmonary Sleep and Critical Care',
    "Children's Hospital Center of Akron- Psychiatry",
    'Mercy Health - JACBCC',
    'Mercy Health - Columbiana Imaging and Lab Services',
    'Mercy Health - Howland Imaging',
    'Mercy Health - Austintown Imaging and Lab Services',
    'Mercy Health - St Elizabeth Boardman Orthopaedics Imaging',
    'Holzer Clinic LLC - Rheumatology',
    "Mercy Health - St Rita's Rheumatology",
    'Arena Eye Surgeons',
    'Mercy Health - East Palestine Primary Care',
    'Jeffries Chiropractic & Wellness',
    'American Health Network - Gahanna',
    'Access Counseling Services LLC',
    'Worthington Foot & Ankle',
    'The Childrens Home of Cincinnati',
    'Holzer Clinic LLC - Emergency Medicine',
    'Holzer Clinic LLC - Orthopedic Surgery',
    'Healthy Alliance LLC',
    'Mercy Health - Neuroscience Institute Neurology',
    'Harding Behaviorial Health Physicians',
    'Mount Carmel Medical Group TriVillage',
    'Medical Home Primary Care Center',
    'Oakview Dermatology',
    'Cleveland Clinic Akron General',
    'OSU Internal Medicine LL',
    'Mercy Health - Perrysburg Walk-In Primary Care',
    'Mercy Health - Waterville Walk In',
    'MH - Swanton Walk-In',
    'Mercy Health - Oregon Walk In Care',
    'Mercy Health - Lambertville Walk-In Care',
    'Joint Implant Surgeons Inc',
    'Mansfield Close To Home Center',
    'Mercy Health - Audiology Clermont',
    'Mercy Health - Audiology Fairfield',
    'Mercy Health - Audiology West',
    'Mercy Health - Audiology Kenwood',
    'Mercy Health - Kings Mills Audiology',
    'Mercy Health - Audiology Anderson',
    'OSU Harding Behavioral Health Physician',
    'Emerald Psychiatry & TMS Center',
    'Mercy Health - Cardiovascular Thoracic Surgeons Fairfield',
    'Mercy Health - Cardiovascular and Thoracic Surgeons West',
    'Mercy Health - Cardiovascular Thoracic Surgeons Kenwood',
    'Mercy Health - Cardiovascular Thoracic Surgeons Anderson',
    'Beckett Springs Physician Group LLC',
    'Mercy Health - The Heart and Vascular Institute Poland Elec',
    'Holzer Clinic LLC - Pediatrics',
    'Mercy Health - East Palestine Physical Therapy',
    'Mercy Health-St Elizabeth Youngstown Medical Intensive Care',
    'Mercy Health - St Elizabeth Boardman Hospital Medical Intensive Care',
    'Midwest Retina Inc',
    'Central Ohio Ophthalmology Inc',
    'Westerville Close To Home Center with Urgent Care - N Cleveland Ave',
    "Nationwide Children's Hospital Emergency Department/Urgent C",
    'Emerald Pediatrics Inc',
    'Mercy Health - The Heart Institute Oxford',
    'Mercy Health - The Heart Institute Fairfield',
    'Mercy Health -The Heart Institute Kyles Station',
    'Mercy Health  - The Heart Institute Kings Mills',
    "Mercy Health - St Rita's Family Medicine Practice",
    "Children's Hospital Center of Akron- Orthopedics",
    'Norton- Kings Daughters Health Inc',
    'American Arthritis & Osteoporosis Care Center',
    'OSU Urology',
    'ACHP-Brecksville',
    "Children's Hospital Center of Akron - ACHP-Brecksville",
    'Capital Park Family Health Center',
    'Genesis Orthopedic Group',
    'Genesis Lung Center',
    'Cleveland Clinic Union Hospital Internal Medicine',
    'PR Care LLC',
    'Mercy Health - West Sleep Medicine',
    'Mercy Health - Liberty Falls Sleep Medicine',
    'Cleveland Clinic Akron General Cardiothoracic and Vascular Surgery',
    'Cleveland Clinic Akron General Cardiology',
    'Aultman Grief Services',
    'Columbus Sleep Consultants',
    "Children's Hospital Center of Akron- Rheumatology",
    'Signature Dermatology LLC',
    'Ohio Physician Professional Corporation dba Aultman Behavioral Health',
    'OSU Emergency Medicine LLC',
    'OSU Observation Medicine LLC',
    "Children's Hospital Center of Akron - ACHP-North Canton",
    'ACHP-North Canton',
    'ACHP - North Canton',
    'Mercy Health - General and Laparoscopic Surgery Fairfield',
    'Mercy Health - General and Laparoscopic Surgery West',
    'Mercy Health - Vascular and Endovascular Surgeons Kenwood',
    "Children's Hospital Center of Akron - ACHP-Medina",
    "Children's Community Practices",
    'Mercy Health - Intermed Hospitalists',
    'Mercy Health - Oregon Clinic',
    "Children's Hospital Center of Akron- Neurosurgery",
    'Holzer Clinic LLC - Audiology',
    'Licking Memorial Otolaryngology',
    'Mercy Health - Breast Surgery Fairfield',
    'Mercy Health - Breast Surgery Deerfield',
    'Mercy Health - Deerfield Breast Surgery',
    'Mercy Health - Springfield Medical Center Telestroke',
    'Mercy Health - Urbana Hospital Telemedicine',
    'Arrows Counseling Center LLC',
    'Allwell Behavioral Health Services',
    'Licking Memorial Gastroenterology',
    'Digestwell LLC',
    'Mount Carmel Gastroenterology',
    "Mercy Health - Youngstown Women's Center",
    'Mercy Health - St Elizabeth Boardman Labor and Delivery',
    'Child Focus Inc',
    'ACHP Alliance',
    "Mercy Health - BHI St Rita's Psychiatry",
    'OSU Health System-Hospital at Home',
    "Children's Hospital Center of Akron",
    'ACHP-Austintown',
    'ACHP',
    'ACHP - ENT',
    'Physicians Group of Southeastern Ohio Inc',
    'Mercy Health - Youngstown General Surgery',
    'Health First Medical Center',
    'Mercy Health - Maineville Urgent Care',
    'Cambridge Specialty Center',
    'Genesis FirstCare',
    "Mercy Health - St Rita's Intensivists",
    'Mercy Health - Springfield Heart House',
    'Mercy Health - Springfield Heart Failure Center',
    'Mercy Health - Enon Heart House',
    'Mercy Health - Urbana Heart House',
    'Living Hope Primary Health Care LLC',
    "Nationwide Children's Hospital Big Lots Behavioral Health Hospital",
    'Fairfield Healthcare Professionals Orthopedics',
    'Fairfield Healthcare Professionals New Lexington Specialty',
    'Muskingum Valley Health Center',
    'Pain Management Group LLC',
    'OSU Plastic Surgery LLC',
    'Orrville Alliance Family',
    'Family Medicine of Alliance',
    'Mount Carmel Medical Group Grove City',
    'Susan Fortney Harlan',
    'Michael B Shannon MD',
    'Mercy Health -  Columbiana Primary Care',
    'Mercy Health - Salem Primary Care',
    'Mercy Health -  North Lima Primary Care',
    'Goodwin Foot & Ankle Center PLLC',
    'Mercy Health - Defiance Clinic Nephrology',
    'Mercy Health - Nephrology Hospitalists',
    'OSU GYN and OB Consultants  LLC',
    'Mid Ohio Ophthalmic Consultants',
    'Oxford Medical Health and Wellness Center LLC',
    "Nationwide Children's Hospital Cardiology Clinic",
    'Aultman Radiation Oncology',
    'Cleveland Clinic Union Hospital Obstetrics and Gynecology',
    "D'Amato Chiropractic Clinic",
    "Children's Hospital Center of Akron- Heart Center",
    'ACH - Heart Center',
    'Fairfield Community Health Center',
    'Spielman Comprehensive Breast Center',
    'Mercy Health - Orthopaedics and Spine Fairfield',
    'Mercy Health - Orthopaedics and Spine West',
    'Mercy Health - Ortho and Sports Medicine Eastgate',
    "Nationwide Children's Hospital Neurology Clinic",
    'Health One Inc',
    "Children's Hospital Center of Akron- Outpatient Therapy",
    'Mercy Health - Sebring Imaging and Lab Services',
    'Buckeye Dermatology Inc',
    'Buckeye Dermatology',
    'Mary Rutan Pediatrics',
    'Mary Rutan Urbana Specialty Clinic',
    'Aultman Medical Group Canton Plastic Surgeons',
    'Aultman Medical Group Plastic Surgery',
    "Nationwide Children's Hospital Primary Care Center-Westside",
    "Children's Hospital Center of Akron- PIRC",
    'ACHP - Boardman',
    'Selby General Hospital',
    'Cleveland Clinic Akron General Behavioral Medicine',
    'Genesis Medical Group Heart & Vascular - Coshocton',
    'Mercy Health - Urbana Hospital Family Medicine & Pediatrics',
    'AMG Family Medicine of Alliance',
    "Children's Hospital Center of Akron - Sports Medicine",
    "Children's Hospital Center of Akron- Sports Medicine",
    "Mercy Health - St Rita's Neuroscience and Rehabilitation",
    'Mount Carmel Medical Group Pickerington',
    'Mercy Health - East Palestine Walk-In Care',
    'Mercy Health - Newton Falls Primary Care',
    'OSU Radiology LLC',
    'Mount Carmel Medical Group Powell',
    'Mount Carmel Acute Care - St Anns',
    'Wesley Forgue MD LLC',
    'Mercy Health - West Park Family Medicine',
    "Hospitalists of St Rita's",
    'ACHP-Green',
    'Mercy Health - Church Hill Primary Care',
    'Fairfield Healthcare Professionals Cardiothoracic Surgery',
    'Mercy Health - Center for Diabetes Care and Endocrinology-Boardman',
    'OSU Family Practice Services',
    'BSMH Tele Psychiatry Program',
    "Licking Memorial Women's Health- Pataskala",
    'Licking Memorial Womens Health',
    "Licking Memorial Women's Health- Granville",
    "Licking Memorial Women's Health- Newark",
    "Licking Memorial Women's Health- Downtown",
    'Holzer Clinic LLC - Urgent Care',
    'Hocking Valley Community Hospital Rural Health Clinic',
    'CarePoint Gahanna',
    'Columbus Ophthalmology Center I Ltd',
    'Fairfield Healthcare Professionals',
    'Quality Care Associates Urgent Care and Wellness Center',
    'OSU GYN and OB at CarePoint',
    'Cleveland Clinic Akron General Neurosciences',
    'Mercy Health - Findlay Obstetrics & Gynecology',
    'Mercy Health - Tiffin Obstetrics and Gynecology',
    'Genesis Primary Care Physicians LLC',
    'Mercy Health - Wapakoneta Neurology',
    'Mercy Health - Perrysburg Physical Medicine and Rehab',
    "Mercy Health - St Rita's Neurology",
    'New Day Therapy',
    'Hopewell Helath Centers Inc',
    'Family Counseling and Rehabilitation Center of Ohio',
    'Mercy Health - Interventional Neurology',
    'Mercy Health - General and Surgical Oncology Kenwood',
    'Cleveland Clinic Akron General Internal Medicine',
    "Children's Hospital Center of Akron- Urology",
    'Mercy Health - Neuro Hospitalists',
    'Wieging Family Chiropractic',
    'Zanesville Neurology LLC',
    'Boulder Care Provider Group',
    'ACHP- Boardman',
    'ACHP-Warren Downtown',
    "Children's Hospital Center of Akron - Diagnostic Referrals-Akron",
    "Children's Hospital Center of Akron- Pulmonology",
    'ACH - Pulmonology',
    'Marietta Health Care PhysiciansInc',
    'Holzer Clinic LLC - Pain Medicine',
    'Fairfield Healthcare Professionals Cardiology',
    'Mercy Health - St Elizabeth Youngstown Radiation Oncology',
    'Mercy Health - St Joseph Warren Radiation Oncology',
    'Mercy Health - St Elizabeth Boardman Radiation Oncology',
    'Mercy Health - Vascular and Endovascular Surgeons Fairfield',
    'The Counseling House LLC',
    'Northside Womens Health',
    'Mount Carmel Medical Group Sedalia',
    'Holzer Clinic LLC -  Internal Medicine',
    'Mercy Health - Oberlin General Surgery',
    'Mercy Health - Lorain General Surgery',
    'Mercy Health - The Heart Institute Milford',
    'Mercy Health - The Heart Institute Anderson',
    'Student Health Services *OSU Students Only',
    'Genesis ENT Group',
    'Fairlawn Family Practice Inc',
    'ACHP Lisbon',
    'Mercy Health Psych - St Vincent',
    'Mercy Health Psych - West Park',
    'Mercy Health - Oregon Walk-In Family Medicine',
    'Ohio Sleep Medicine Institute',
    'Mount Carmel Acute Care - MCE',
    'Barnesville Family Health Center',
    'Orthopaedic Associates of Zanesville',
    'Monroe Family Health Center',
    'Better Minds Group',
    'ACH Care Center',
    'Mary Rutan General Surgery',
    'Mary Rutan Internal Medicine',
    'Mary Rutan Family Care',
    'Mary Rutan Jackson Center Family Care',
    'Mercy Health - Behavioral Health Institute Oregon',
    'Psychological Consultants and Affiliates Inc',
    'Mercy Health - Tiffin Hospital',
    "Nationwide Children's Hospital Infectious Disease Clinic",
    'Coshocton Regional Medical Center',
    'Aultman Medical Group Kevin Hill MD',
    'AMG Kevin Hill MD',
    'Licking Memorial Professional Corporation',
    "The Children's Home of Cincinnati",
    'Mercy Health - Cardiac Physicians Management',
    'Holzer Clinic LLC - Wound Care',
    'Dr Rex Chiropractic Inc',
    'Mercy Health - Perrysburg Infectious Disease',
    'Mercy Health - Infectious Disease',
    'Mercy Health - Howland Primary Care',
    'Mercy Health - Youngstown Primary Care',
    'American Health Network - Grove City Family Practice',
    'Mercy Health - Wound Care Fairfield Hospital',
    'US Institute for Advanced Sinus Care and Research',
    'Mercy Health - Shawnee Family Medicine',
    'Mercy Health - General and Laparoscopic Surgery Anderson',
    'Northeast Dermatology LLC',
    'River View ENT Center of Central Ohio',
    'River Valley Orthopedics & Sports Medicine Inc',
    'Columbus Arthritis Center Inc',
    'PrimeCare of Southeastern Ohio Inc',
    'Foot & Ankle Specialists of Central Ohio LLC',
    'Doudna Chiropractic LLC',
    'Longworth Chiropractic Clinic Inc',
    'The Childrens Home of Cincinnati  Loveland High School',
    'The Chiildrens Home of Cincinnati Wyoming High School',
    'The Childrens Home of Cincinnati Wyoming Elementary Primary',
    'The Childrens Home of Cincinnati Wyoming Middle School',
    'The Childrens Home of Cincinnati Wyoming Vermont Primary',
    'The Childrens Home of Cincinnati  Hyde Park School',
    'The Childrens Home of Cincinnati Wyoming Hiltop Primary',
    "The Children's Home of Cincinnati - ECS",
    'The Childrens Home of Cincinnati Loveland Primary',
    'The Childrens Home of Cincinnati Loveland Elementary',
    'The Childrens Home of Cincinnati Diamond Oaks',
    'The Childrens Home of Cincinnati Loveland Intermediate School',
    'The Childrens Home of Cincinnati Loveland Middle School',
    "Children's Hospital Center of Akron - ACHP-New Philadelphia",
    "Children's Hospital Center of Akron- NDC- Phys Med",
    'ACHP - NDC - Neurology',
    "Children's Radiological Institute",
    'On The Couch: Clinical Psychotherapy & Professional Consultation',
    'Counseling and Wellness Center LLC',
    'The Center for Personal Empowerment',
    'Brighten Up Counseling',
    'UPS Dermatology',
    'Kburton DPM LLC',
    "Nationwide Children's Hospital Rheumatology Clinic",
    'Mercy Health - Forest Park Internal Medicine and Pediatrics',
    'Mercy Health - Fairfield Psychiatry',
    'Holzer Clinic LLC - General Surgery',
    'Holzer Clinic LLC - Internal Medicine',
    'Columbus Inpatient Care Inc',
    'Mercy Health Psych - Weight Management',
    'Mercy Health Psych - St Charles',
    'ACHP - Orthopedic Surgery',
    'Mercy Health - Neuroscience Center Youngstown Neurology',
    "Children's Community Practice LLC dba Hand in Hand Pediatrics",
    'ACHP East Liverpool',
    'ACHP Boardman',
    'Valley Gastroenterology and Endoscopy',
    'Mercy Health - Eastside Urgent Care',
    'Westerville Close To Home Center - West Schrock Rd',
    'Southeastern Ohio Counseling Center LLC',
    'Student Health Services',
    'Holzer Clinic LLC - Neurology',
    'Pediatrics of Akron',
    'Licking Memorial Family Practice - Tamarack',
    'Licking Memorial Family Practice- Hebron',
    'Mercy Health - Bay Meadows Family Medicine',
    'ACHP-Akron East',
    'Mercy Health - Perrysburg Primary Care',
    'Mercy Health - Waterville Primary Care',
    'DR MIODRAG ZIVIC LLC',
    'Mercy Health - The Heart and Vascular Institute Warren Cardiology',
    'Mercy Health - Oberlin Urology',
    'Mercy Health - Lorain Urology',
    'Family Foot & Ankle Center Inc',
    'Precision Orthopaedic Specialties',
    'Sleep and Breathing Research Institute',
    'Mercy Health - St Elizabeth Youngstown Neurology',
    'Pediatric Ophthalmology Associates',
    'C',
    'Mount Carmel Medical Group North',
    'Newcomerstown Union Physician Services',
    'John N Larrimer MD Inc',
    'Westar Obstetrics & Gynecology LLC',
    'ACHP - Palliative Care',
    'Genesis Heart & Vascular Group',
    'Mt Lookout Chiropractic and Sports Injury Center',
    'Jeffrey VanMeter MD Inc',
    'ACHP - Amherst Health Center',
    'Mercy Health - St Elizabeth Internal Medicine',
    'Mercy Health-Austintown Outpatient Rehab and Therapy',
    "Nationwide Children's Hospital Endocrinology Clinic",
    "Children's Hospital Center of Akron- NDC-Developmental Pediatircs",
    'ACHP - Ophthalmology',
    'ACH - Ophthalmology',
    'Central Ohio Eye Physicians & Surgeons Inc',
    'Associates in Central Ohio OB/Gyn Inc',
    'Mercy Health - Howland Ear Nose and Throat',
    'Mercy Health - Kenwood Neurology',
    'Allergy & Immunology',
    'Lifeway Counseling Centers Inc',
    'Mercy Health - Lima Family Medicine',
    'Mercy Health - Amberley Village Primary Care',
    'Mercy Health - West Chester Family Medicine',
    'ACHP-Diagnostic Referrals',
    'Acute Care Surgery Service at Akron',
    'Mercy Health - Jewish Palliative Medicine',
    'Holzer Clinic LLC',
    'Union Physician Services Family Health Center North',
    'UPS Central',
    'Cleveland Clinic Akron General Surgery',
    'Hocking Valley Medical Group',
    'ACHP Marietta',
    'Mercy Health - Poland Sleep Medicine',
    'Rajesh Madan MD PC',
    'OSU Family Practice Service',
    "Children's Hospital Center of Akron - ACHP-Solon",
    'Mercy  Health - Social Services',
    "Nationwide Children's Hospital Primary Care Center-Hilltop",
    "Nationwide Children's Hospital Primary Care Center - Hilltop",
    "Nationwide Children's Hospital Primary Care Center - Eastland",
    "Nationwide Children's Hospital Primary Care Center-Eastland",
    'EORH Physicians Group- East Ohio Hospital LLC',
    'Geise Chiropractic LLC',
    'Fairfield Healthcare Professionals Internal Medicine Residency Clinic',
    'Gallipolis Chiropractic and Wellness Center',
    'Mercy Health - Boardman Neurohospitalist',
    'Lisa Bates LLC',
    'Mercy Health - Howland Occupational Therapy',
    'Mercy Health - Austintown Occupational Therapy',
    'Mercy Health - Boardman Rehabilitation',
    'Mount Carmel Medical Group Granville',
    'Mount Carmel Breast Surgery',
    'Summit Rehabilitation Medicine Inc',
    'Family Health Care Center',
    'Christine Habib MD LLC',
    'Mercy Health - Perrysburg Surgical Specialists',
    'Cummins Womens Health Care LLC',
    'Fairfield Healthcare Professionals Family Medicine of Millersport',
    'AMG Family Medicine of North Canton',
    'Aultman Medical Group Allison Oprandi MD',
    'Franzens Chiropractic & Wellness Center',
    'Mercy Health - Fairfield Pulmonary Sleep & Critical Care',
    'Mercy Health - Jefferson Avenue Surgery Clinic',
    'Central Ohio Geriatrics LLC',
    "Children's Anesthesia Associates Inc",
    'Moses & Mouser MDs Inc',
    'ACHP - Emergency Medicine',
    "Children's Hospital Center of Akron- Emergency Medicine",
    'Hope Counseling LLC',
    'Mt Auburn Nephrology Inc',
    'Columbus Metropolitan Obstetrics & Gynecology Inc',
    'ACHP - Pulmonology',
    'ACHP - Neonatology',
    'Mercy Health - Clermont Pulmonary Sleep and Critical Care',
    'Mercy Health - Warren General Surgery',
    'Mercy Health - Boardman General Surgery',
    'Mercy Health - Defiance Clinic Obstetrics',
    'Mount Carmel Medical Group Hilliard Britton Pkwy',
    'Mercy Health - Sandusky Pain Management',
    'MH - Respiratory Specialists',
    'Mercy Health - Respiratory Specialists',
    'MH Hospital Vascular/Pulmonary Clinic Outreach',
    'MHC Physicians Inc',
    'Alpine Family Medicine',
    'Holzer Clinic LLC - Covid Vaccine Clinic',
    "Children's Hospital Center of Akron- Hematology/ Oncology",
    "Nationwide Children's Hospital Main Aquatic",
    'Mercy Health - Kenwood Internal Medicine',
    'Mercy Health - Intermed Internal Medicine',
    'Mercy Health - Swanton Walk In',
    'Mercy Health - St Vincent Walk-In Primary Care',
    'Jones-Wood Psychological Associates',
    'Mercy Health Psych - FCC',
    'Genesis Dresden Family Practice',
    'Medical and Surgical Associates Inc',
    "Children's Hospital Center of Akron- Surgery",
    'ACHP - Urgent Care',
    'Holzer Clinic LLC - Cardiology',
    'Mercy Health – Wapakoneta Family Medicine',
    'Mercy Health - Spencerville Family Medicine',
    'Central Ohio Skin & Cancer Inc',
    'Genesis Endocrinology',
    'Mercy Health - Sheffield Primary Care',
    'Mercy Health - Lorain Primary Care',
    'Mercy Health - St Charles Nocturnist',
    'Myers & Miller Podiatry Inc',
    'Hospitalist Medicine Physicians of Ohio PC',
    "Nationwide Children's Hospital Neonatal Infusion Clinic",
    'Mount Carmel Colon & Rectal Surgery',
    'Mercy Health - Columbiana Podiatry',
    'Mercy Health - Salem Podiatry',
    'Mercy Health - North Lima Podiatry',
    'Mercy Health - The Heart Institute Kenwood',
    'Zangmeister Cancer Center',
    'Oberlander and Associates Internal Medicine Inc',
    "Mercy Health - St Rita's Ear Nose and Throat",
    'Hypertension and Kidney Specialists LLC',
    'Aultman Hematology & Oncology',
    'Mercy Health - Kenton Kidney & Hypertension',
    'Mercy Health - Joint Township Kidney & Hypertension',
    'Mercy Health - Tiffin Kidney and Hypertension',
    'Mercy Health - Putnam County Kidney & Hypertension',
    "Mercy Health - St Rita's Kidney & Hypertension",
    'Mercy Health - Celina Kidney & Hypertension',
    'Mercy Health - Eastside Kidney & Hypertension',
    'Mercy Health - Sheffield Neurosurgery',
    'American Health Network - Fredericktown',
    'Kaplansky Foot & Ankle Centers',
    'Mary Rutan OB-GYN',
    'Mercy Health - Cardiovascular Thoracic Surgery',
    'Westerville Pediatric Specialists Inc',
    'Mercy Health - Tiffin General Surgeons',
    'Mercy Health - Columbiana Flu Clinic',
    'Mercy Health - Struthers Primary Care',
    'Mercy Health - Oberlin Behavioral Health',
    'Mercy Health - Lorain Behavioral Health',
    'Mercy Health - Wellington Primary Care',
    'Mount Carmel Neurology',
    'Licking Memorial Endocrinology',
    'ACHP - Hematology/ Oncology',
    'Allergy Unlimited LLC',
    'Licking Memorial Pediatrics',
    'Licking Memorial Pediatrics East',
    'Licking Memorial Health Center at Licking Heights',
    'South Zanesville Family Medical Center',
    "Nationwide Children's Hospital Primary Care Center - Northland",
    "Nationwide Children's Hospital Primary Care Center -Northland",
    'Mercy Health - St Charles Family Medicine',
    'Aultman Medical Group Hematology and Oncology',
    "Mercy Health - St Rita's Cancer Center",
    'Mercy Health - Celina Medical Oncology',
    'St Anns Family Practice Center',
    'Mercy Health - Swanton Primary Care',
    'Mercy Health - Springfield Medical Center Neurology',
    'Aultman Medical Group Family Medicine of Stark County',
    'Mount Carmel Medical Group Grove City Family Health',
    'DUBLIN SPRINGS PHYSICIAN GROUP LLC',
    "Mercy Health - St Rita's Specialty Center",
    'HolyHills Healthcare Services LLC',
    'American Health Network - East Main',
    'Mercy Health - Columbus Grove Family Medicine',
    'Mercy Health - St George Primary Care',
    'Mercy Health - Austintown Primary Care',
    'Mountain State Medical Specialties Inc',
    'Mercy Health - Allison Radiation Oncology',
    'Mercy Health - Celina Radiation Oncology',
    'Mercy Health - Harrison Primary Care',
    'Mercy Health - Defiance Clinic General Surgery',
    'Mount Carmel Palliative Care',
    'Mount Carmel Hospice',
    'Whitehall Medical Center Inc',
    "Nationwide Children's Hospital Dermatology Clinic",
    "Children's Hospital Center of Akron - ACHP-Wadsworth",
    'Robert Hall MD LLC',
    'Robert P Zaino MD LLC',
    'Mercy Health - Mercy Crest Family Medicine',
    'Fairview Hospital',
    'Ward Therapy Associates',
    'Genesis Uryogynecology - Coshocton',
    'Forefront Dermatology',
    'Mercy Health - The Heart and Vascular Institute Ygst Thorac',
    'ACHP - Diagnostic Referrals-Akron',
    'Mercy Health - Village Square Pediatrics',
    'Akron Childrens Hospital-Dermatology',
    'Mercy Health - Lighthouse Way Family Medicine',
    'Heart of Ohio @ Canal Winchester',
    'ACHP-Barberton',
    "Children's Hospital Center of Akron - ACHP-Barberton",
    'Mercy Health - St Elizabeth Boardman Orthopaedics and Sports Medicine',
    'Mercy Health - Enon Orthopaedics and Sports Medicine',
    'Mercy Health - Springfield Orthopaedics and Sports Medicine',
    'Mercy Health - Oak Point Primary Care and Specialty',
    'Cleveland Clinic Akron General Sports & Ortho Injury Care',
    'Holzer Clinic LLC - Psychiatry',
    'Genesis Cancer Care Center',
    'Mercy Health - Oak Hills Internal Medicine',
    'Key Pain Management and Treatment Center Inc',
    'Mercy Health - Howland Physical Therapy',
    'Aultman Deuble Heart & Vascular Hospital',
    'Fairfield Healthcare Professionals Family Medicine of Amanda',
    'American Health Network - Grant Bexley',
    'Mercy Health - Lorain Surgical Assist',
    "Children's Hospital Center of Akron - ACHP-Perry Township",
    'ACHP-Diagnostic Referrals-Aultman',
    'Diagnostic Referrals-Aultman',
    'ACHP - Diagnostic Referrals-Aultman',
    'ACHP - Diagnostic Referrals',
    'Advanced Cardiovascular Care LLC',
    'Mercy Health - The Heart Institute Georgetown',
    'Mercy Health- The Heart Institute Mt Orab',
    "Nationwide Children's Hospital Allergy Clinic",
    'Mount Carmel Medical Group New Albany',
    "Nationwide Children's Hospital ENT Clinic",
    'Holzer Clinic LLC - Urology',
    'AultWorks Occupational Medicine',
    'Mercy Health - St Joseph Warren Medical Oncology',
    'Mercy Health - St Elizabeth Boardman Medical Oncology',
    'Lisa Knight Flarey DO Inc',
    'Cardiovascular Specialists LLC',
    'Cardiovascular Specialist',
    'UPS Regional Surgical Specialists',
    'Demetrio J Agcaoili MD LLC',
    'Mercy Health - Family Physicians of Springfield',
    "Nationwide Children's Hospital Primary Care Center - Westside",
    'Kantner Chiropractic Care',
    'Zanesville Chiropractic & Physical Therapy',
    'Zanesville Medical Center dba Columbus Knee & Joint Medical Center',
    'Counseling & Wellness Center LLC',
    'The Retina Group Inc',
    'Mary Rutan Plastic Surgery',
    'The Childrens Home of Cincinnati  Great Oaks',
    'The Childrens Home of Cincinnati ECS',
    'The Childrens Home of Cincinnati  South Avondale',
    "Children's Hospital Center of Akron- Pediatric Urgent Care",
    'Jones-Wood Psychological Associates Inc',
    'Mercy Health - Lorain Trauma Surgery',
    "Nationwide Children's Hospital Gastroenterology Clinic",
    'Wooster Clinic LLC CRP',
    'Mercy Health - Wick COVID IMM',
    'Mercy Health - Eisenhower Covid IMM',
    'Quaker City Family Health Center',
    'Caldwell Family Health Center',
    'Ohio Hills Health Center Belmont Career Center',
    'Mercy Health - West Clermont Family Medicine',
    'Mercy Health - St Paris Family Medicine',
    'Mercy Health - Springfield Family Medicine',
    'Mercy Health - Springfield Walk-in Care',
    'Mercy Health - Urbana Internal Medicine',
    'Mercy Health - Defiance Walk-In Care',
    'Ohio Psychiatric Associates Inc',
    'Liberty Counseling & Consultation LLC',
    'Mercy Health - Austintown Speech Therapy',
    'Mercy Health - Boardman Speech Therapy',
    'ACHP - Diagnostic Referrals-Youngstown',
    'ACHP-Ashland',
    'Mercy Health - Cancer Center',
    'EORH Physician Group-East Ohio Hospital LLC',
    'AMG Hematology & Oncology',
    'Mercy Health - Church Hill General Surgery',
    'Dollison Chiropractic Office',
    'Mercy Health - CSMOC Crestview Hills',
    'Mercy Health - Orthopaedics and Spine Kenwood',
    'Mercy Health - Orthopaedics and Spine Mason',
    'Mercy Health - Ortho and Sports Medicine Anderson',
    'Fairfield Medical Health Partners of Hocking Valley',
    'Fairfield Primary Care',
    'Mercy Health - Red Bank Pain Management Center',
    'Mercy Health - Pain Medicine West',
    'Northeast Ohio Nephrology Associates',
    'Licking Memorial Heart Center',
    'Steven B Wootton DC LLC',
    'Eye Specialists Inc',
    'Mercy Health - Oncology Hematology Care Springfield',
    'Mercy Health - Oakley Psychology',
    "Children's Hospital Center of Akron- Endocrinology",
    'ACHP - Endocrinology',
    'Mercy Health - Franklin Avenue Obstetrics and Gynecology',
    'Aultman Geriatric Assesment Center',
    'Aultman Geriatric Assessment Center',
    "Children's Hospital Center of Akron-Plastic Surgery",
    'ACHP - Dermatology',
    "Children's Hospital Center of Akron-Dermatology",
    "Children's Hospital Center of Akron- Dermatology",
    'Genesis Palliative Care Specialist',
    "Hospitalists of St Rita's - Van Wert Health",
    'Mercy Health - East OB/GYN',
    "Children's Hospital Center of Akron- Maternal/Fetal Medicine",
    'Childrens Hospital of Akron-Maternal/Fetal',
    'Akron Childrens Hospital Center- Maternal/ Fetal',
    'Mercy Health - Howland Audiology',
    'Mercy Health - Austintown Audiology',
    'Mercy Health - Boardman Audiology',
    'Mercy Health - Toledo Trauma Recovery Center',
    'Mercy Health - Blue Ash Psychology',
    'Mercy Health - Kenwood 210 Psychology',
    'Mercy Health - Urbana Walk-in Care',
    'Holzer Clinic LLC - Gastroenterology',
    'ACHP - Neonatal Subintensive Care-NICU',
    'ACH - Neonatal Subintensive Care-NICU',
    "Nationwide Children's Hospital Westerville Aquatic Center",
    'Fairfield Healthcare Professionals Dba Infection Prevention Associates',
    'Fairfield Healthcare Professionals Wound Clinic',
    'Central Ohio General Surgeons',
    'Mercy Health – Defiance Walk-In Care',
    'ACHP - Diagnostic Referrals-Warren',
    'Sistersville Rural Health Clinic',
    'Mercy Health - CSMOC Deerfield',
    'Licking Memorial Family Practice - East',
    "Children's Hospital Center of Akron - ACHP",
    'Ohio Dermatology Center',
    'Perry County Family Practice',
    "Children's Hospital Center of Akron- Psych-Triple P",
    'Licking Memorial Outpatient Psychiatric Services',
    'Ohio State University-CAP',
    'Aultman Orthopedics and Sports Medicine',
    'OSU Physicial Medicine & Rehabilition LLC',
    'Mercy Health - Fairfield Sleep Medicine',
    'Mercy Health - Kenwood Sleep Medicine',
    'Mercy Health - Mason Sleep Medicine',
    'Mercy Health - Oberlin Gastroenterology',
    'Mercy Health - Lorain Gastroenterology',
    'Mercy Health - Infectious Disease Clermont',
    'Mercy Health - Wound Care Clermont Hospital',
    'Lisa Flarey DO Inc',
    'Mohammed Ahmed MD Inc',
    'Cornerstone Counseling and Consulting Services LLC',
    'Poland Family Chiropractic Inc',
    'University Cardiology',
    'Mercy Health - Austintown Orthopedics and Sports Medicine',
    'Mercy Health - Dent Crossing Family Medicine',
    'Licking Memorial Neurology',
    'Mercy Health - Austintown Ear Nose and Throat',
    'Cleveland Clinic Akron General Gastroenterology',
    'Mercy Health - Mercy Crest Pulmonology',
    'Mercy Health - Senior Behavioral Unit Springfield',
    'Mercy Health - Senior Behavioral Health Unit',
    'Mercy Health - Palliative Medicine',
    'Mercy Health - Springfield General & Laparoscopic Surgery',
    'Mercy Health - Wittenberg University Health Center',
    'Mercy Health - Urbana General & Laparoscopic Surgery',
    'Mercy Health - Blue Ash Family Medicine',
    'Aultman Medical Group Behavioral Health & Counseling Center',
    "Nationwide Children's Hospital Ontario Close to Home",
    'Licking Memorial Wound Services',
    "Mercy Health - St Rita's Palliative Care",
    'ACHP - Sports Medicine',
    'PARS Healthcare',
    'Beacon Orthopaedics and Sports Medicine',
    'Acute Care Surgeons LLC',
    'Worst Day Ever LLC',
    'Aultworks Alliance',
    'Aultman Weight Management North Canton Medical Center Entrance B',
    "Nationwide Children's Hospital Pulmonary Clinic",
    "Children's Hospital Medical Center Of Akron",
    'Mount Carmel Medical Group Westerville Maxtown',
    'Cleveland Clinic Akron General Obstetrics and Gynecology',
    'ACHP Urgent Care',
    'Innovative Family Medicine',
    'Debra Freehauf McFadden',
    'Mercy Health - Perrysburg Neurology',
    'Mercy Health - St Vincent Neurology',
    'Prime MD Pediatrics',
    "Children's Hospital Center of Akron - Endocrinology",
    'ACH - Endocrinology',
    "Akron Children's Hospital Pediatrics Portage",
    'NDC-Phys Med',
    "Mercy Health - Children's Hospital Surgery",
    "Children's Hospital Center of Akron- Ophthalmology",
    'Genesis Breast Cancer Center',
    'Fairfield Healthcare Professionals Gastroenterology',
    'Mercy Health - Bluffton Cardiology',
    "Mercy Health - St Rita's Cardiology",
    'Mercy Health - Willard Pain Management',
    'Mercy Health - Tiffin Hospital Physical Medicine & Rehabilitation',
    "Children's Hospital Center of Akron - ACHP-Kent",
    'ACHP - Urology',
    'Mid Ohio Behavioral Health LLC',
    'Hygge Behavioral Health &  Wellness',
    'Mercy Health - St Elizabeth Boardman Orthopaedics and Sports Medicine Walk-In Care',
    'Mount Carmel Medical Group Grove City Stringtown',
    'Mercy Health - St Elizabeth Youngstown Palliative Care',
    'Mercy Health - St Joseph Warren Palliative Care',
    'Mercy Health - St Elizabeth Boardman Palliative Care',
    'Mount Carmel Psychiatry',
    'Orthopaedic Specialists & Sports Medicine',
    'EORH Physician Group- East Ohio Hospital LLC',
    "Mercy Health - St Rita's Psychology",
    "Children's Hospital Center of Akron- NDC-Neurology",
    'Mercy Health - Howland Orthopedics and Sports Medicine',
    'Zanesville Pediatrics',
    'Mercy Health - Northparke Internal Medicine',
    'Licking Memorial Family Practice North',
    'ACHP Beachwood',
    'Mercy Health NWOPCP Starbright Family Medicine',
    'Mercy Health - Starbright Primary Care',
    'Aultman Medical Group Medcorp',
    'Aultman Medical Group North Canton Medical Center Flu Clinic West',
    'Coshocton Regional Medical Center Family Physicians',
    'Coshocton Regional Medical Center Arrowhead Clinic',
    'David R Lawrence DO LLC',
    'Mercy Health - Oak Point Primary Care',
    'Mercy Health - Westside Psychology',
    'Mercy Health - Dent Psychology',
    'Family Practice WestCare',
    'Family Foot and Ankle Center Inc',
    'Family Foot and Ankle Inc',
    'ABC Pediatrics of Ohio LLC',
    'ABC Pediatrics of Ohio',
    'Foot and Ankle Specialists of Central Ohio LLC',
    'Bell Consultation Services LLC',
    'Genesis Urology Group',
    'ACHP - Orthopedics',
    "Children's Hospital Center of Akron - ACHP-Warren",
    "Children's Hospital Medical Center of Akron- ACHP Hudson",
    'ACHP - Brecksville',
    'ACHP-Twinsburg',
    'Mercy Health - Behavioral Health Institute',
    'Mercy Health - Behavioral Health Institute Boardman',
    'Eastwind Womens Health Inc',
    "Licking Memorial Women's Health",
    'Mid-Ohio Behavorial Health LLC',
    'Mercy Health - Eisenhower Primary Care',
    'Premier Urology Corp',
    'Hunter Family Chiropractic',
    "Mercy Health - St Rita's Heart Failure Clinic",
    'Primary OneHealth',
    'Mount Carmel Medical Group Pataskala',
    'Mercy Health - Lorain Vascular and Interventional Radiology',
    'Mount Carmel Urgent Care',
    'AMG Family Medicine of Navarre',
    'Cleveland Prime Care Belmont LLC',
    'Mercy Health - St Vincent Medical Center OB Dept',
    'Columbus Nephrology Inc',
    'Licking Memorial Pediatrics-Newark',
    'Mercy Health - The Heart Institute Batesville',
    'Mercy Health - The Heart Institute Harrison',
    'Mercy Health - The Heart Institute Bridgetown',
    'Aultman Orthopedics and Sports Medicine Massillon',
    'Cardinal Pediatrics',
    'Mercy Health - The Heart Institute Mason',
    "Children's Hospital Center of Akron- Pediatric Medicine-Locust Pediatric Care Group",
    'Powell Chiropractic Clinic',
    'Mercy Health - Sheffield Obstetrics and Gynecology',
    'Premier Allergy and Asthma Inc',
    'Genesis Neurosurgery Group',
    'Mercy Health - Perrysburg Gyn-Oncology',
    'Mercy Health - St Vincent Gynecologic Oncology',
    'Fairfield Medical Occupational Health',
    "Children's Hospital Center of Akron - Burn Unit",
    'Mercy Health - Lung Nodule Clinic',
    'Harrison Community Hospital Inc',
    'Harrison Community Hospital',
    'Cleveland Clinic Akron General Gynecologic Oncology',
    'Wheeling Hospital Center for Pediatrics',
    'Mercy Health - Canfield Primary Care',
    'Mercy Health - Stutz Primary Care',
    'Mercy Health - Talsman Primary Care',
    'Mercy Health Psych - Sylvania',
    'Northtowne Family Practice',
    'Mercy Health - Youngstown Hepatobiliary and Pancreatic Ctr',
    'Mercy Health - Howland General Surgery',
    'Mercy Health - North Lima General Surgery',
    'OSU General Internal Medicine',
    'Hilliard Family Podiatry LLC',
    'Northeast Ohio Nephrology Associates Inc',
    'Genesis Wound Care Center',
    'Mercy Health - St Vincent Primary Care',
    'Priority Medical Family Practice',
    'Genesis Occupational Employee Health Services',
    'Mount Carmel Obstetrics and Gynecology Easton',
    'Mercy Health - Lorain Flu Clinic Oberlin',
    'Mercy Health - Lorain Flu Clinic Lorain',
    'Mercy Health - Lorain Geriatrics',
    'Wesleyan Village',
    'Hope & Wellness Counseling & Consultation LLC',
    'Mercy Health - Sardinia Family Medicine',
    'Buckeye Family Health LLC',
    'Cleveland Clinic Akron General Endocrinology',
    'Mercy Health - Post Intensive Recovery Center',
    'ACHP - Psychiatry',
    'Maple Leaf Family & sports Medicine',
    'Fairfield Healthcare Professionals Orthopedics and PMR',
    'Fairfield Healthcare Professionals Amanda',
    'Advanced Chiropractic and Rehab Inc',
    'Genesis Interventional Pain Management',
    'Mid Ohio Neurology Inc',
    'Mercy Health - Franklin Avenue Pediatrics',
    'Mercy Health - Navarre Pediatrics',
    'Mount Carmel OSU Physician Alliance',
    'Ohio Digestive Care LLC',
    'Holzer Clinic LLC - Endocrinology',
    'Harrison Professional Group',
    'Mercy Health - Westside Internal Medicine',
    'Susan Early Vallade LISW',
    "Children's Hospital Center of Akron - Critical Care",
    'Wheeling Hospital Center for Pediatrics/Pediatric Rehabilitation',
    'Amjad Rass MD',
    '1730 Southgate Pkwy',
    'American Health Network - Hilliard',
    'Marietta Health and Wellness Center LLC',
    'Parkersburg High School Health and Wellness Center',
    'Parkersburg Family Care B',
    'West Virginia University at Parkersburg Health and Wellness Center',
    'Licking Memorial Urgent Care- Granville',
    'Licking Memorial Urgent Care- Newark',
    'Aultman Hospital Physicians',
    'Orthopedic Foot & Ankle Center',
    'Lodi Community Care Center',
    "Children's Hospital Center of Akron - ACHP-Hudson",
    'ACHP- Boston Heights',
    'Mercy Health - Myrtle Ave Primary Care',
    'Mercy Health Tiffin Hospital Primary Care',
    'Quality Care Associates',
    'ACHP-Medina',
    'Mercy Health - The Heart and Vascular Institute Willard',
    'Mercy Health - The Heart and Vascular Institute Tiffin',
    'Genesis Medical Group',
    'Genesis Medical Group  LLC',
    'Mercy Health - The Heart Institute Clermont',
    'Mercy Health - Orthopaedics and Sports Medicine Eastgate',
    'Mercy Health - Orthopaedics and Sports Medicine Anderson',
    'Mountain State Medical Specialties PLLC',
    'Mercy Health - Vermilion Primary Care',
    'Mercy Health - Lorain Flu Clinic Amherst',
    "Nationwide Children's Hospital Lewis Center Close to Home",
    'Canal Winchester Sports PT Clinic',
    'Five Clinics LLC',
    'Tuscarawas Health Center of Aultman Orrville Hosptial',
    'Harmony Chiropractic Center',
    'Mercy Health - Franklin Avenue Internal Medicine',
    'ACHP-Wooster',
    'Eye Care & Surgery Associates Inc',
    'Mercy Health - Howland Podiatry',
    'Mercy Health - Ortho and Sports Medicine Oxford',
    'Mercy Health - Ortho and Sports Medicine West Chester',
    "Nationwide Children's Hospital Behavioral/Learning Disability",
    "Nationwide Children's Hospital Behavioral/Learning Disabilit",
    'Holzer Clinic LLC - Interventional Cardiology',
    'Cleveland Clinic Akron General Neurology',
    'Metro Psychiatry Inc',
    'Mercy Health - Anderson Pulmonology Sleep and Critical Care',
    "Nationwide Children's Hospital Surgery Clinic",
    'Primetown Ohio LLC',
    'Medina Family Chiropractic Center',
    'BSMH Remote Patient Monitoring Program',
    'Donay Chiropractic of Marysville',
    'Donay Chiroprac??c of Marysville',
    'Mercy Health - Cardiothoracic Surgical Associates',
    "Mercy Health - St Rita's Cardiothoracic & Vascular Surgery",
    'Universal Dermatology LTD',
    'Mercy Health - Springfield Plastic Surgery',
    'Licking Memorial Urology',
    "Nationwide Children's Hospital Orthopaedic Clinic",
    'OSU Nisonger Center',
    'Mercy Health - Point Shoreland Family Medicine',
    'Beckett Springs Pysician Group LLC',
    'Craig Czyz DO',
    'Southern Local Schools Wellness  Cntr',
    'MHC Physician Inc',
    'Angela DelVecchio LPCC',
    'Licking Memorial Internal Medicine',
    'Mindfulness LLC',
    'Mercy Health - Wapakoneta Pain Management',
    'Mercy Health – Bellefontaine Pain Management',
    'OrthoNeuro Dublin',
    'Coshocton Regional Medical Center Warsaw Clinic',
    'Mount Carmel Medical Group Franklinton',
    'Mercy Health - Pemberville Primary Care',
    'Mercy Health - Lorain Infectious Disease',
    'Aultman Medical Group Neurosurgery',
    'Marietta Health Care Physicians Inc',
    'Crosswoods Womens Health Inc',
    "Nationwide Children's Hospital Primary Care Center -South Hig",
    "Nationwide Children's Hospital Primary Care Center - South High",
    "Mercy Health - Children's Hospital Hematology and Oncology",
    'Mercy Health - Winton Road Primary Care',
    'FAIRLAWN FAMILY PRACTICE',
    'Fountain City Chiropractic and Rehabilitation',
    "Nationwide Children's Hospital Dental Clinic",
    'Mercy Health - Evendale Family Medicine',
    'Genesis Pulmonary/Critical Care Specialist',
    'Marion Chiropractic Clinic',
    'Dublin Spring Physcian Group LLC',
    'Mercy Health - Waterville Family Medicine',
    'R Maureen Murphy PhD',
    "Nationwide Children's Hospital Primary Care Center - Linden",
    "Nationwide Children's Hospital Primary Care Center -Linden",
    'Capital City Health',
    "Nationwide Children's Hospital NICU at Dublin Methodist Hospital",
    'Fairfield Healthcare Professionals Rheumatology',
    'American Arthritis & Rheumatology Assocs OH LLC',
    'Mount Carmel Obstetrics and Gynecology',
    'MEDMOCO LLC',
    "Children's Hospital of Akron- Diagnostic Referrals- Akron",
    'Akron Childrens Hospital- Urgent Care',
    "Children's Hospital Center of Akron- Diagnostic Referrals- Akron",
    'ACHP - Oberlin',
    'ACHP- Barberton',
    'BRONDON FOOT AND ANKLE',
    'Mercy Health - St Vincent Orthopaedics',
    'Hygge Behavioral Health & Wellness LLC',
    'Mercy Health - Kenwood Neurosurgery',
    'Mercy Health - Oberlin Orthopedics and Sports Medicine',
    'Mercy Health - Lorain Orthopedics and Sports Medicine',
    'Mercy Health - Oak Point Orthopedics and Sports Medicine',
    'Mercy Health - Avon Walk-In Care',
    'Mercy Health - Lorain Flu Clinic',
    'Mercy Health - Lorain Primary Care and Specialists',
    'Mercy Health – Lorain Flu Clinic Sheffield ',
    'Amjad Rass MD Inc',
    'Hygge Behavioral Health and Wellness',
    'Mercy Health - Ortho and Sports Medicine Blue Ash',
    'Mercy Health - Orthopaedics and Spine West Chester',
    'Mercy Health - St Elizabeth Youngstown Neuroscience',
    'ACHP - Portage',
    'Allied Health & Chiropractic LLC',
    'Mercy Health - St Charles Wound Care and Hyperbaric Center',
    'Mercy Health - St Anne Hospital Wound Care',
    'Westland Family Care LLC',
    'Angela B Wallenbrock MD',
    'FHP PHYSICAL MEDICINE & REHAB',
    'Holmes Spine and Sport Chiropractic Clinic',
    'Tranquility Psychiatry and Counseling Services',
    'Columbus Podiatry and Surgery Inc',
    'Columbus Skin Surgery Center',
    'OSU Onternal Medicine LLC',
    'Mercy Health - Deerfield Family Medicine',
    'Mercy Health - Deerfield Family Medicine and Specialists',
    'Fairfield Healthcare Professionals CHF Clinic',
    'Nancy Alkire MD LLC',
    'Mercy Health - Defiance Clinic Podiatry',
    'Mercy Health - Defiance Clinic Wound Care',
    'Mercy Health - Napoleon Clinic Podiatry',
    'Mercy Health - Henry County Podiatry',
    'Cleveland Clinic Akron General Sports Medicine',
    'Canyon Eye Associates Inc',
    'Surgical Associates of Canton of OPPC',
    'Coshocton Chiropractic Health Center',
    'Mercy Health - Youngstown Ear Nose and Throat',
    'Holzer Clinic LLC - OB/Gyn',
    'Westerville Surgery Center',
    'Ohio Specialty Physicians Group',
    'ACHP - Gastroenterology',
    'Gastroenterology',
    'Integrated Health Center LLC',
    'Mark Johnson Chiropractic PSC',
    'Licking Memorial Professional Corp',
    'Ayesu Health Plus',
    'Pediatrix Medical Group',
    'Mercy Health - Weight Management Solutions and Surgical Specialties',
    'Mercy Health - Tiffin Weight Management Solutions',
    'Fairfield Healthcare Professionals Emergency Services Social Worker',
    'EORH Physician Group - East Ohio Hospital LLC',
    'Coshocton Regional Medical Center Pain Clinic',
    'Coshocton Regional Medical Center Urgent Care',
    'Coshocton  Regional Medical Center Arrowhead Clinic',
    'Tru-Rob Counseling & Consulting',
    'TRU-ROB Counseling & Consulting LLC',
    'Mercy Health - Defiance Clinic Hospitalists',
    'Mercy Health - Springfield Rheumatology',
    'ACHP -  Wadsworth',
    'ACHP - Millersburg',
    'ACHP-Wadsworth',
    'ACHP - Medina',
    'Mercy Health - Napoleon Walk In Clinic',
    'Mercy Health - Howland Speech Therapy',
    'Aultman Medical Group Mansard Medical',
    'Mercy Health - Springfield Wound Care Center',
    'JB Winters DO LLC',
    'Pars Neurosurgical Associates',
    'Mercy Health - The Neuroscience Institute Neurosurgery',
    'Aultman Neurosurgery',
    'Orrville Hospital Foundation',
    'EORH Physician Group East Ohio Hospital LLC',
    'Mercy Health - Warren Primary Care',
    'Mercy Health - Henry County Family Medicine',
    'Mercy Health - Glandorf Family Medicine',
    'Lighthouse Family Chiropractic',
    'Mercy Health - Oregon Podiatry',
    'Mercy Health - West Toledo Podiatry',
    'Thomas Kramer MD Inc',
    'Mercy Health - Monfort Heights Family Medicine',
    'ACHP Millersburg',
    'ACHP- Wooster',
    'Phillips Chiropractic and Wellness Center LLC',
    'FAIRFIELD HEALTHCARE PROFESSIONALS VASCULAR SURGERY',
    'Holzer Clinic LLC - Critical Care',
    'Parkersburg Family Care-Westbrook',
    'Wirt County Health Services Association Inc  DBA  Parkersburg Family Care B',
    "Mercy Health - St Rita's Vascular Surgery",
    "Nationwide Children's Hospital Adolescent Health/Teen Clinic",
    'Licking Memorial Pediatrics- Newark',
    "Mercy Health - St Mary's Neurosurgery",
    "Mercy Health - St Rita's Neurosurgery",
    "Mercy Health - St Rita's Neurosurgery Center - Celina",
    'ACHP-Mansfield',
    'Mercy Health - Urbana Pulmonology',
    'Hopewell Health Centers',
    'Satinder S Bhullar MD',
    'Mercy Health - Champion Primary Care',
    'Mercy Health - Perrysburg Heart and Vascular Institute',
    'Mercy Health - Heart & Vascular Institute',
    'Mercy Health - Heart and Vascular Institute',
    'Mercy Health - Tiffin Vascular Clinic',
    'Mercy Health - West Toledo Heart & Vascular',
    'Mercy Health - St Charles Heart & Vascular Institute',
    'Mercy Health - Waterville Cardiology',
    'Toledo Cardiology Consultants Inc',
    'Mercy Health - Swanton Cardiology',
    'Mercy Health - Lambertville Cardiology',
    'ABC Podiatry',
    'Impact Health & Wellness',
    'Holzer Clinic LLC - Family Medicine (Wound Care)',
    'Mercy Health - Oberlin Endocrinology',
    'Mercy Health - Lorain Endocrinology',
    'Mercy Health - Tri-County Primary Care',
    'Gilson Chiropractic',
    'Mercy Health - Springfield Cancer Center',
    'Counseling and Wellness Center',
    'ACHP -  Heart Center',
    'Oakview Dermatology LLC',
    'OSU Internal Medince LLC',
    'Columbus Eyelid Plastic Surgery LLC',
    'Mercy Health - Urbana Orthopedics and Sports Medicine',
    'Mercy Health - Endo Cholesterol & Diabetes Fairfield',
    'Mercy Health - Endo Cholesterol and Diabetes Anderson',
    'Mercy Health - Adams County Psychology',
    'Mercy Health - West Clermont Psychology',
    'Mercy Health - Colerain Psychology',
    'Mercy Health - Anderson Psychiatry',
    'Newark-Granville Psychological & Counseling Services Ltd',
    'Mercy Health - Sebring Primary Care',
    'Mercy Health - Milford Family Medicine',
    'Mercy Health – Transitions of Care',
    'Sistersville General Hospital',
    'Mercy Health - Neurology Fairfield',
    'Mercy Health - Neurology Anderson',
    'Mercy Health - Defiance Clinic Plastic Surgery',
    'East Ohio Orthopaedics',
    'East Ohio Orthopedics',
    'Professional Providers Networking LLC',
    'Marieta Memorial Hospital',
    'OSU Occupational Medicine',
    'ACH - Sports Medicine',
    'American Health Network - Geriatrics',
    'Virginia A Reid PhD',
    'Mercy Health - Avondale Internal Medicine',
    'Fairfield Healthcare Professionals Psychiatry',
    'Mercy Health - Fallen Timbers Orthopaedics and Sports Medicine',
    'LaRue Psychiatric Services LLC',
    'Cleveland Clinic Akron General Hematology and Oncology',
    'DePerro Plastic  Surgery LLC',
    'Cleveland Clinic Akron General Urogynecology',
    'East Ohio Hospital LLC Physician Group',
    'Medical Associates of Cambridge Inc',
    "Mercy Health - St Rita's Neurosurgery Center - Bluffton",
    'Siebria Health Services',
    'Mercy Health - Liberty Falls Family Medicine',
    'Aultman Orrville Carrollton Health Center',
    'Aultman Orrville Carrollton Schools Health Center',
    'Fairfield Healthcare Professionals  Pulmonology-Critical Care',
    'Fairfield Healthcare Professionals Logan Specialty Clinic',
    'ACHP - Neurology',
    'Lancaster Surgical Associates Inc dba Central Ohio General Surgeons',
    'Aultman Orrville Pain Management',
    'ACHP - Adolescent Medicine',
    'Mercy Health - Starbright Psych',
    'Mercy Health - Columbiana Physical Therapy',
    'Mercy Health - Columbiana Orthopedics Walk In Care',
    "Children's Hospital Center of Akron- Speciality Care Nursery",
    'Maple Leaf Family & Sports Med',
    "Children's Hospital Center of Akron- Palliative Care",
    'Manning Family Chiropractic',
    'Mercy Health - Gynecology Monfort Heights',
    'Creekside Chiropractic Center',
    'Fairfield Healthcare Professionals Neurology',
    'SonRise Pediatrics and Wellness',
    'ACHP-Streetsboro',
    'Columbus Springs Dublin- changes',
    'Columbus Springs East',
    'Columbus Springs Dublin-changes',
    'Columbus Springs Dublin',
    'ACHP - Plastic Surgery',
    'Mercy Health - Primary Care at Home',
    'Dr Margery J Shupe LPCC',
    'Beckett Springs Changes',
    'Kauffman Chiropractic LLC',
    'Holzer Clinic LLC - Orthopedic Spine Surgery',
    "Children's Hospital Center of Akron- NDC-Neuro Behavioral Health",
    "Akron Children's Hospital-Barberton",
    "Children's Hospital Center of Akron - ACHP-Ravenna",
    'Mercy Health - Neuroscience Center',
    'Mercy Health - Springfield General & Robotic Surgery',
    'Mercy Health - Jefferson Avenue Family Medicine',
    'UPS Pulmonary and Sleep Center',
    'Mercy Health - Wick Primary Care at YSU',
    'Mercy Health - North Lima Primary Care',
    'Licking Memorial Rheumatology',
    'Mercy Health - Youngstown Stroke Care',
    'Mercy Health - Youngstown Muscular Dystrophy/Multiple Sclero',
    'Mercy Health - Boardman Neurology',
    'The Boster Center for Multiple Sclerosis',
    'Levey Innovative Therapeutics',
    'Mercy Health - Howland Sleep Medicine',
    'Mercy Health - North Lima Sleep Medicine',
    'Mercy Health - Rookwood Primary Care',
    'Mercy Health - Oakley Primary Care',
    "Mercy Health - Women's Center at Kenwood Towne Centre",
    'ACHP - Warren',
    'Shelly Thompson MD Inc',
    'Beacon Orthopaedic & Sports Medicine Ltd',
    'Sawmill Chiropractic Inc',
    'Center For Sight',
    'Colonnade Medical Group Inc',
    'Scott Anzalone MD',
    "Children's Hospital Center of Akron- Wadsworth PCP Group",
    'Akron Childrens Hospital Pediatrics Urgent Care',
    'Cleveland Clinic Akron General Breast Surgery',
    'James A Sides MD',
    'Lundeberg Chiropractic',
    'Counseling & Wellness Center',
    'Southeastern Ohio Physicians',
    'Mercy Health - Willard Hospital Neurology',
    'Mercy Health - Tiffin Hospital Neurology',
    'Psycare Inc - Russell I Voltin MD',
    'Psycare Inc',
    'Psycare Inc TMS of Parkersburg',
    "Children's Hospital Center of Akron - ACHP-Tallmadge",
    'Mercy Health- The Heart Institute Eastgate',
    'Mercy Health - The Heart Institute Lawrenceburg',
    'JILL SANER LISW LLC',
    'Mercy Health - Clinton Street Walk-In Family Medicine',
    'Mercy Health - Lambertville Walk-In Family Medicine',
    'Mercy Health - Fairfield Psychology',
    'Mercy Health - Ear Nose and Throat Clermont',
    'Mercy Health - Ear Nose and Throat Kenwood',
    'Mercy Health - Ear Nose and Throat Eastgate',
    'Mercy Health - Ear Nose and Throat Anderson',
    'Mount Carmel Medical Group Diley Ridge',
    "Children's Hospital Center of Akron - ACHP-Green",
    'Wheeling Hospital',
    'Mercy Health - UNOH Family Medicine',
    "Nationwide Children's NICU at Mount Carmel St Ann's",
    'Mercy Health - Kenwood Family Medicine',
    'Mercy Health - Ear Nose and Throat Fairfield',
    'Mercy Health - Ear Nose and Throat West',
    'Mercy Health - Kings Mills Speech Language Pathology',
    'OhioDerm Holding LLC',
    'OhioDerm Holding  LLC',
    'Mercy Health - Defiance Clinic Cardiology',
    'Custom Care NP Services LLC',
    'Mercy Health - Lorain Physical Medicine and Rehabilitation',
    'Orthopedic & Neurological Consultants Inc',
    'Mercy Health - Vascular and Endovascular Surgeon Edgewood',
    'Mercy Health - Vascular and Endovascular Surgeons West',
    'Mercy Health - Vein Solutions',
    'Valley Gastroenterology & Endoscopy',
    'AMG Bolivar Medical Center',
    'Aultman North Canton Medical Group/ dba; AMG Canton South Medical Center',
    'Aultman Medical Group Family Medicine of North Canton',
    "Children's Hospital Center of Akron - Diagnostic Referrals-Youngstown",
    'Akron General Childrens- Emergency Medicine',
    'ACHP - Diagnostic Referrals - Youngstown',
    'Hand and Microsurgery Associates Inc',
    'AMG Behavioral Health & Counseling Center',
    "Children's Hospital Center of Akron-Sports Medicine",
    'Gentner Chiropractic & Wellness LLC',
    'Robert E Sams MD PLLC',
    'Genesis Heart Lung & Vascular Group',
    'Mercy Health - Perrysburg Cancer Center',
    'Toledo Clinic Inc',
    "Nationwide Children's Hospital Psychiatry Clinic",
    'Bridgewater Counseling and Consulting Ltd',
    "Children's Hospital Center of Akron- Psych Burn Unit",
    'Aultman Orrville Bolivar Health Center',
    'Mercy Health - Defiance Clinic Behavioral Health',
    'Mercy Health - Columbiana General Surgery',
    'Dover Health Center of Aultman Orrville Hospital',
    'Mercy Health - St Vincent Urology Hospitalists',
    "Children's Hospital Center of Akron - Adolescent Medicine",
    'Mercy Health - Howland Physical Medicine and Rehabilitation',
    'Mercy Health - The Heart and Vascular Institute Youngstown Electrophysiology',
    'Licking Memorial Pediatrics - East',
    'Fairfield Healthcare Professionals Internal Medicine',
    'Mercy Health - Kings Mill Primary Care',
    'Mercy Health - Defiance Clinic Diabetic Education',
    'Mercy Health - Henry County Diabetic Education',
    'Muskingum Pediatrics',
    'Womens Comprehensive Health Center',
    'Genesis Heart and Vascular Group',
    'Orthpaedic Institute of Dayton',
    "Mercy Health - St Rita's Pulmonary",
    'Mercy Health - The Heart Institute Sardinia',
    "Nationwide Children's Hospital Apnea Clinic",
    'Fairfield Healthcare Professionals- Logan Primary Care',
    'Fairfield Healthcare Professionals Logan',
    'Parkersburg High School Wellness Center',
    'Dierker Physicians LLC',
    'Integrative Chiropractic Clinic',
    'Infectious Disease Consultants Inc',
    "Children's Hospital Center of Akron- Nephrology",
    'ACHP-Liberty',
    'Genesis Hematology and Cancer Treatment Center',
    "Children's Hospital Center of Akron- Urgent Care",
    'Mercy Health - Maternal Fetal Medicine Clinic',
    "Children's Hospital Center of Akron- Neonatal Subintensive Care-NICU",
    "Children's Hospital Center of Akron - Diagnostic Referrals-Wooster",
    'FORME Medical & Rehabilitation Center of Findlay Inc dba Kirk Chiropractic',
    'Henry County Hospital General Surgery Clinic',
    'Mercy Health - Avondale Psychology',
    'Mercy Health - Oak Hills Psychology',
    'Genesis New Lexington Family Practice',
    'Mercy Health - Springfield Neurosurgery',
    'Mercy Health - General & Laparoscopic Surgery West',
    'Village Medical Center LLC',
    'Mercy Health - St Charles Hospital',
    'Mercy Health - Navarre TelePsych',
    'Clinic Physician Services Co LLC',
    'SerenaGroup Professional Services PC',
    'Mercy Health - Great Lakes Gastroenterology',
    'Mercy Health - Boardman Chiropractic Care',
    'Elite Foot and Ankle LLC',
    'DR PRAKASH M PATEL',
    'Aultman Medical Group General Surgery',
    'Mercy Health - Sylvania Family Medicine',
    'Mercy Health - Cortland Primary Care',
    'Minorik Chiropractic',
    'Westland IM Inc',
    'Edgmon Family Medicine',
    'Ironton Chiropractic Wellness',
    "Children's Hospital Center of Akron - ACHP-Akron East",
    "Children's Hospital Center of Akron-Orthopedics",
    'Anderson Hills Chiropractic',
    'Psych Solutions Inc',
    "Children's Hospital Center of Akron Maternal/Fetal Medicine",
    "Akron Children's Maternal Fetal Med",
    "Children's Hospital Center of Akron-Surgery",
    "Mercy Health - St Rita's General Surgery",
    'Mount Carmel Medical Group Taylor Station',
    'Foot and Ankle Physicians of Ohio',
    'Professionals for Womens Health',
    'Pain Magagement Group LLC',
    'Centerpointe Chiropractic and Physical Therapy',
    'Eye Surgery Associates of Zanesville Inc',
    "Mercy Health - St Luke's Internal Medicine",
    'Holzer Clinic LLC - Radiation Oncology',
    'Genesis Heart & Vascular Gruop',
    'Metropolitan Family Care Inc',
    'Integrated Rehab Consultants LLC',
    'Holzer Clinic LLC - Medical Oncology',
    'Central Ohio Wound Ostomy Services LLC',
    'Southeastern Ohio Regional Medical Center Inc',
    'Ohio Valley Dermatology Zanesville Office',
    'Ohio Valley Dermatology',
    'Aultman Gynecologic Oncology',
    'Anesthesiology & Pain Management',
    'McMichael Chiropactic',
    'ACHP - Maternal/Fetal Medicine',
    'Mercy Health - Weight Management Solutions Fairfield',
    'Mercy Health - Weight Management Solutions Kenwood',
    'Mercy Health - Weight Management Solutions Anderson',
    'Mercy Health - Talsman General Surgery',
    'Orthopedic Foot and Ankle Center Worthington',
    'Mercy Health - In-House OB-GYN',
    'Mercy Health - Austintown Podiatry',
    'Genesis Palliative Care',
    'Mount Carmel Acute Care - MCGC',
    'Mercy Health - Wyoming Primary Care',
    'Pulmonary and Sleep Consultants LLC',
    'Brian D Short DPM',
    'Mercy Health - Tiffin Hospital OB Locums',
    'Mount Carmel Medical Group Johnstown',
    'Albert Corbin Psychological Services',
    'ACHP Psychiatry',
    'Fairfield Pulmonary and Critical Care Associates',
    'Brechbill Chiropractic',
    'Hypertension-Nephrology Consultants Inc',
    'Gena Grigson LCSW',
    'Gena Grigson LISW',
    "Nationwide Children's Hospital Physical Medicine Clinic",
    'Mercy Health - Van Wert Cardiology',
    'Fairfield Healthcare Professionals Vascular',
    'Mercy Health - General and Laparoscopic Surgery Avondale',
    'Mercy Health - West Colon and Rectal Surgery',
    'Mercy Health - Colorectal Surgery Kenwood',
    'Mercy Health - General and Laparoscopic Surgery Mason',
    'MH - Lambertville Walk-In Family Medicine',
    'UPS MOB Center North First Care',
    'ACH - Orthopedics',
    'Mercy Health - Milford Family Medicine Suite 100',
    'Reichert Family Chiropractic',
    'Hygge Behavioral Health & Wellness',
    'Genesis Somerset Family Practice',
    'Midwest Internal Medicine Associates',
    'Mercy Health - Enon Primary Care',
    "Mercy Health - Warren Women's Center",
    'St Henry Chiropractic LLC',
    'Vasu Medical Group Inc',
    'Worthington Chiropractic Center',
    'Childrens Hospital Center of Akron Orthopedics',
    'Dr Jennifer Bullock Allergy and Asthma LLC',
    'Chiropractic Care Inc',
    'Mid-Ohio Neurology',
    'ACH - Urology',
    'Colleen Fink MD',
    'Fairfield Healthcare Professionals- Family Medicine of Amanda',
    'Fairfield Pulmonary Critical Care Associates',
    'Mercy Health - Maumee Pain Medicine',
    'ACHP - Heart Center',
    "Children's Hospital Center of Akron - Heart Center",
    'ACHP Heart Center',
    'Womankind Health & Wellness Center',
    'Mercy Health - West Toledo Dermatology',
    'Fairfield Healthcare Professionals OB/GYN',
    'Freeport Family Health Center',
    'Mercy Health - Willard Hospital Primary Care',
    'Mercy Health - Dry Ridge Family Medicine',
    'Lifeline Counseling LLC',
    'Mercy Health - Belmont Primary Care',
    'Mercy Health - Infectious Disease Springfield',
    'OrthoNeuro Pickerington Urgent Care',
    'OrthoNeuro New Albany',
    'OrthoNeuro Westerville',
    'Mercy Health - Van Wert Medical Oncology',
    "Nationwide Children's Hospital NICU at Riverside Methodist Hospital",
    'Mount Carmel Health Stations',
    'Licking Memorial Gynecology',
    'Mercy Health - Vascular and Endovascular Surgeons Anderson',
    'Licking Memorial Vascular Surgery',
    'Licking Memorial Tamarack',
    'Swiss Valley Foot and Ankle',
    'ACHP - Wadsworth PCP Group',
    'Mercy Health-St Elizabeth Internal Medicine',
    'Schmit Chiropractic Office',
    'Sazdanoff Chiropractic',
    'Revive Health and Injury Center LLC',
    'Aultman Pain Management',
    'ACMG General Surgery',
    'ACMG Pain Management',
    'Mercy Health - Austintown General Surgery',
    'Mercy Health - Youngstown CVIC Intensivist Service',
    'Mercy Health - Heart & Vascular Institute - Magruder',
    'Mercy Health - Springfield Obstetrics and Gynecology',
    'Mercy Health - North Lima Imaging and Lab Services',
    'Mercy Health - Anderson Hospital Residency Program',
    'AULTMAN WEIGHT MANAGEMENT N CANTON MEDICAL CENTER ENTRANCE B',
    'ACH Pediatric Psychiatry & Psychology Boardman',
    'Greg Wise MD Inc',
    'Frederic A Humphrey DO Inc',
    'Columbus Family Practice LLC',
    'Mercy Health - St Anne Palliative Care',
    'Sistersville General Medical Center',
    'Mercy Health - Sunforest Primary Care',
    'Columbus Medical Services On Call',
    'Aultman Medical Group Breast Surgery Specialists',
    'Broeg Chiropractic & Nurtition Center',
    "Children's Hospital Center of Akron - Neonatology",
    'Mercy Health - The Heart Institute Rookwood',
    'Mercy Health - Heart Failure Clinic',
    'First Settlement Orthopaedics Inc',
    'Mercy Health - Anderson Pulmonary Sleep Critical Care',
    'Mercy Health - Defiance Clinic Dermatology',
    "Children's Hospital Center of Akron- Hospital Medicine",
    'The High Road LLC',
    'Kidney Specialists Inc',
    'Holzer Clinic LLC - Podiatry',
    'AMG North Canton Medical Center',
    'Mark J Demalio DC Inc',
    'Dermatology and Cosmetic Surgery of Dublin Inc',
    'Aultman Alliance Family Medicine of AOH',
    'Mercy Health - Maumee Bay General Surgery',
    'Girraj Bansal MD',
    'Melody D Heydinger DC Prof Corp',
    'Holzer Clinic LLC - Cardiac Electrophysiology',
    'Thomas Magness MD',
    'OSU Sports Medicine Center',
    "Children's Hospital Center of Akron- Surgery Admin",
    'Comprehensive Pain Management Specialists',
    'Healthworx LLC',
    'Henry County Hospital Urology',
    "Mercy Health - St Rita's Urology",
    'Modern Allergy LLC',
    "Children's Hospital Center of Akron - Neurology",
    'Delaware Podiatry Center LLC',
    'Central Ohio Comprehensive Foot Care LLC',
    'Cosmetic & Plastic Surgery of Columbus Inc',
    'Mount Carmel Medical Group East',
    'Mercy Health - East Sleep',
    'Harold A Gillespie II MD',
    'ACHP-Hudson',
    'Sierra Willis LLC',
    'Licking Memorial Pediatrics- Tamarack',
    'Licking Memorial Pediatrics- East',
    'OSU East Physicians Services',
    'Aultman Orrville Claymont Schools Health Center',
    "Children's Hospital Center of Akron- Radiology",
    'Cater-Mallett Medical Services Inc',
    'Aultman Medical Group Christopher Chow MD',
    'Chivington Chiropractic',
    "Mercy Health - St Rita's Wound and Ostomy Care",
    'Columbus Chiropractic Center of Dublin',
    'Chapel Street Chiropractic',
    "Children's Hospital Center of Akron- Surgery Pre-op",
    'Mercy Health - General and Laparoscopic Surgery Kenwood',
    'Southern Local Wellness Center',
    'Mercy Health - Bluffton Kidney & Hypertension',
    'Mercy Health - Putnam General Surgery',
    'Mercy Health - Coldwater Kidney & Hypertension',
    'Mercy Health - The Heart and Vascular Institute Ygst Vasc',
    'Family Healthcare Partners',
    'Physical Therapy Specialists of Ohio',
    'Ability Chiropractic Westerville',
    "Children's Hospital of Akron-ACHP- Green Primary Care Office",
    'Mary Rutan Specialty Clinic',
    'Orthopedic Foot and Ankle',
    'Dublin Springs Physcian Group LLC',
    'Dublin Springs Physcian LLC',
    'Mercy Health - Orthopaedics and Sports Medicine Milford',
    'Mercy Health - Orthopaedics Kings Mills',
    'Mercy Health - Lorain Palliative Care',
    'Mercy Health - Palliative Cancer Center',
    'Arndt Chiropractic & Nutritional Health',
    'Fairfield Healthcare Professionals Physical Medicine & Rehabilitation',
    'Mercy Health - Brandywine Primary Care',
    'Beverly Medical Center',
    'Mercy Health - Anderson Primary Care',
    'Steiman Neurology Group Inc',
    'Mercy Health - Wapak Cardiology',
    "Heart Specialists of St Rita's - Joint Township",
    'Mercy Health – Putnam Cardiology',
    'Richard F Reckman PhD',
    'Fairfield Healthcare Professionals Hematology & Oncology',
    'Fairfield Healthcare Professionals Hematology-Oncology',
    'Fairfield Medical Center Hematology-Oncology',
    'FAIRFIELD HEALTHCARE PROFESSIONALS dba Fairfield Pulmonary and Critical care Associates',
    'FAIRFIELD HEALTHCARE PROFESSIONALS dba Diley Ridge Specialty Office',
    'Mercy Health - Defiance Clinic Hematology and Oncology',
    'Mercy Health - Napoleon Clinic Hematology and Oncology',
    'Mercy Health - St Vincent Hematology and Oncology',
    'Mercy Health - St Charles Hematology and Oncology',
    'Mercy Health - Tiffin Hematology and Oncology',
    'Mercy Health - Van Wert Weight Management',
    "Mercy Health - St Rita's Weight Management Solutions",
    'Fairfield Healthcare Professionals New Lexington',
    'Fairfield Healthcare Professionals Specialty Office/Diley Ridge',
    'Licking Memorial Oncology/Hematology',
    'Mercy Health - Avon Podiatry',
    'Mercy Health - Oberlin Podiatry',
    'Mercy Health - Lorain Hospital Wound Care Center',
    'Mercy Health - Sheffield Podiatry',
    'Mercy Health - Oak Point Podiatry',
    'Mercy Health - Tiffin Primary Care',
    'Aultman Immediate Care West',
    'Coshocton Pulmonary Services',
    'Mercy Health - Rookwood Psychology',
    'Mercy Health - Amberley Psychology',
    'Laura I Davis-Perry',
    "Nationwide Children's Hospital Colerain Seating Clinic",
    'Aultworks Orrville',
    'Mercy Health - Behavioral Health Institute Youngstown',
    'Dublin Springs Physician Group',
    'Mercy Health Psych - Swanton',
    'Mercy Health - Rookwood Gynecology',
    'Mercy Health - Gynecology Kenwood',
    'Mercy Health - Gynecology Mason',
    'Licking Memorial Family Practice- North Newark',
    'Medical Consultancy of Ohio',
    'Zanesville Family Practice',
    'Toledo Cardiology  Consultants Inc',
    'Toledo Cardiology Consultants',
    "Children's Hospital Center of Akron- Gastroenterology",
    'ACHP Gastroenterology',
    'Cleveland Clinic Akron General Plastic Surgery',
    'Seth Podiatry Inc',
    'Chandra S Swamy MD a Division of Wheeling Hospital Inc',
    'Holzer Clinic LLC  - Family Medicine',
    "Nationwide Children's Hospital Psychology Clinic",
    'Mercy Health - Trailwood Primary Care',
    'Ellerbrock Spine and Soft Tissue Services LLC',
    'Southeastern Ohio Physicians Inc',
    "Children's Hospital Center of Akron - Care Center",
    'ACHP - Care Center',
    'Central Ohio Vascular Care Inc',
    'Brian N Wright',
    'Aultman Podiatry',
    'Westerville Surgical Specialists',
    "Children's Hospital Center of Akron- PICU Critical Care",
    'Mount Carmel Medical Group Lewis Center',
    'Viewpoint Psychological Services LLC',
    'Breidigan Counseling Services LLC',
    'Mercy Health - Lorain Otolaryngology',
    "Children's Hospital Center of Akron- Specialty Care Amherst",
    'Family Medicine of N Canton',
    'Family Medicine of Stark Hartville',
    'New Horizons Mental Health Services',
    'Genesis Primary Care Physicians',
    'Licking Memorial Family Practice- Granville',
    'Licking Memorial Family Practice- Licking Valley',
    'Northwest Eye Surgeons Inc',
    'Mercy Health - Endo Cholesterol and Diabetes Kenwood',
    'Mercy Health - Endo Cholesterol and Diabetes Deerfield',
    'Fairfield Healthcare Professionals Primary Care New Lexington',
    'Mary Rutan Heart and Vascular Clinc',
    'Nicholas J Phillips DC',
    'Mercy Health - Ortho and Sports Medicine Adams County',
    'Mercy Health - Ortho and Sports Medicine Sardina',
    'Mercy Health - Vermilon Orthopedics and Sports Medicine',
    'Mercy Health - Vermilion Orthopedics and Sports Medicine',
    'Dylan Hunter Chiropractic LLC',
    'Maternal Fetal Medicine',
    'Mercy Health - Youngstown Geriatrics',
    'Robin Swaim DC',
    'Griffin Chiropractic Clinic',
    "Mercy Health - The Neuroscience Institute St Luke's",
    'ACHP - Nephrology',
    'Akron Childrens Hospital - Specialty Care Amherst',
    'ACHP - Radiology',
    'People to People Inc',
    'Sandusky Wellness Center LLC',
    'ACHP Stow',
    'Mary Rutan Specialty Care',
    'Holzer Clinic LLC - Occupational Medicine',
    'Parkersburg Family  Care',
    'Ripley Family  Care',
    'Junction City Family Practice',
    'Mercy Health - Evendale Psychology',
    'Fairfield Medical Urgent Care',
    'David Schaffer MSW LICSW PLLC',
    'Molly King DC PSC',
    'Mt Healthy Chiropractic',
    "Nationwide Children's Hospital Immune Deficiency Clinic",
    'Dailey Chiropractic',
    'Health From Within',
    'OSU Heart Center of Cambridge',
    'CarePoint East',
    "Children's Hospital Center of Akron - ACHP-Ellet",
    'Timothy J Welch LPCC',
    'ACHP Mayfield Heights',
    'Vascura Chiropractic & Rehabilitation Center LLC',
    'Expert Vascular Care of Columbus LLC',
    'Mercy Health - Vermilion Behavioral Health',
    'Mercy Health - Oak Point Behavioral Health',
    'Mercy Health - Wapak Urology',
    'Mercy Health - Celina Urology',
    'Mercy Health - Wound Care West Hospital',
    'Higher Ground Wellness',
    'Mercy Health - Forest Hills Family Medicine Psychiatry',
    'Mercy Health - Anderson Hills Psychiatry',
    'True Life Chiropractic Inc',
    'Mercy Health - St Charles Hospital H&P',
    'ACHP-Boardman',
    'Internal Medicine and Geriatrics Services LLC',
    'Mercy Health - Maumee Bay Obstetrics and Gynecology',
    'Genesis Mecical Group LLC',
    "Mercy Health - St Rita's Allergy & Asthma",
    'Mercy Health - Boardman Maternal Fetal Medicine',
    'Henry County Hospital Cardiology',
    'Fulton County Health Center',
    'Lawrence V Hambrick DC',
    'Stemen Chiropractic Clinic',
    'Krumme Chiropractic',
    'Cardinal Pediatrics PLLC',
    "Dayton Children's Specialty Physicians Inc",
    'Jeffrey A Heller PsyD',
    'Mercy Health - St Rita’s Endocrinology',
    'Courthouse Family Chiropractic LLC',
    'Mercy Health - St Elizabeth Acute Rehabilitation',
    "Children's Hospital Center of Akron-ACHP-Warren Downtown",
    'Fairfield Healthcare Professionals Millersport',
    'Mercy Health - Sebring Physical Medicine and Rehabilitation',
    'Mercy Health - Boardman Physical Medicine and Rehabilitation',
    'Coshocton Regional Family Physicians',
    'Central Ohio Urology Group Inc',
    'Fairfield Healthcare Professionals Primary Care of Diley Ridge',
    'Fairfield HealthCare Professionals Family Medicine of Carroll',
    'ACHP - Surgery-PreOp',
    'Norton Kings Daughters Health',
    'Coshocton Foot Health Center',
    'East Columbus Close To Home Center with Urgent Care',
    'Mercy Health - Wapak General Surgery',
    'Genesis Heart Lung & Vascular',
    'Mercy Health - St Joseph Howland Pain Medicine Center',
    'Mercy Health - Willard Gastroenterology',
    'Mercy Health - Tiffin Gastroenterology',
    'Licking Memorial Family Practice Granville',
    'Mercy Health - Sheffield Gastroenterology',
    'Aultman Medical Group Family Medicine of Alliance',
    'ACHP - PIRC',
    'Fairfield Healthcare Professionals Amanda Specialty',
    'Fairfield Healthcare Professionals Logan Medical Arts',
    'Family Counseling & Rehabilitation Center of Ohio',
    'Mercy Health - Delphos Urology',
    'Mercy Health - Bluffton Urology',
    'Mercy Health - Putnam Urology',
    'Licking Memorial Wound Clinic',
    'Mercy Health - Columbiana Orthopedics',
    'Zaveen A Kureishy MD',
    'Tipp City Chiropractic Center',
    'Brookville Chiropractic Center',
    'ACHP Orthopedics',
    'Mercy Health - Perrysburg Radiation Oncology',
    'Susan Magness-Carver',
    'ACHP - NDC-Neurology',
    'Mercy Health - St Charles Surgical Specialists',
    'Mercy Health - Willard Hospital Urology',
    'Mercy Health - Tiffin Urology',
    "Nationwide Children's Hospital Eye Clinic",
    'Gastro Office LLC',
    'Mercy Health - Oak Hills General & Laparoscopic Surgery',
    'Mercy Health - General and Laparoscopic Surgery Winton Rd',
    'Mercy Health - The Neuroscience Institute Perrysburg',
    'Mercy Health - The Neuroscience Institute Oregon',
    'OSU Interna Medicine LLC',
    'Mercy Health - Kyles Station Primary Care',
    'Mercy Health - General and Laproscopic Surgery Dent',
    'Holzer Clinic LLC - Post Acute',
    'Mercy Health - Lorain Weight Management Solutions',
    'Mercy Health Urgent Care LLC',
    'Byers Chiropractic Center',
    'Stiegler Chiropractic Inc',
    'N8 Family Chiropractic',
    'N8 Family Chiropractic of Lancaster Main St',
    'N8 Family Chiropractic Inc',
    'N8 Family Chiropractic of Canal Winchester',
    'The Counseling House',
    'Pro Adjuster',
    'Licking Memorial Behavioral Health',
    'Mercy Health - West Internal Medicine and Pediatrics',
    'Mercy Health - Putnam Pain Management',
    'Signature Dermatology',
    "Nationwide Children's Hospital Ohio Pediatric Care Alliance",
    'Essential Sports & Spine Solutions',
    'Aultman Hematology and Oncology',
    'Mount Carmel Medical Group Westerville',
    'Womens Integrative Medicine OB/GYN LLC',
    'Dublin Close To Home Center - Venture Dr',
    "Nationwide Children's Hospital Cystic Fibrosis Clinic",
    'Cleveland Clinic Union Hospital Family Medicine Dr Jones',
    'Mercy Health - Clark State Health Center',
    'Mercy Health - Urogynecology Clermont',
    'Mercy Health - Urogynecology and Female Pelvic Medicine',
    'Mercy Health - Urogynecology Kenwood',
    'Cheatle Chiropractic & Rehab Center',
    'Donna S Barasch Inc',
    'MSW Solutions LLC',
    'Mercy Health - Ada Family Medicine',
    'Mercy Health - Milford OBGYN',
    'Fairfield Healthcare Professionals Pulmonology',
    'Mercy Health - Defiance Clinic Vascular Surgery',
    "The Childrens's Home of Cincinnati",
    'Mary Rutan Interventional Radiology',
    'Bentley Chiropractic Inc',
    'John M Lepi MD Inc',
    'Newark Granville Psychological & Counseling Services LTD',
    'Marietta Memorial Hospital Dept of Pulmonology',
    'ACHP-Tallmadge',
    'AMG Family Medicine of Louisville',
    'Family Medicine of Hartville',
    "Mercy Health - St Rita's Neurosurgery Center",
    'ACHP - Diagnostic Referrals - Wooster',
    'GU Ohio LLC',
    'Coshocton Regional Medical Center Surgery Clinic',
    'Drayer Physical Therapy',
    'Westerville Natural Medicine LLC',
    "Children's Hospital Center of Akron- Sleep Medicine",
    'Licking Memorial Hospital Company Care',
    'Southeastern Surgery',
    'Connections Christian Counseling',
    'Mercy Health - Springfield Flu Clinic',
    'Schubach Chiropractic Inc',
    'David W Ray DO LLC',
    'OhioHealth Southeastern Medical Center',
    'PsyCare Inc - Daniel Thistlethwaite MD',
    'Ohio State University Orthopedic',
    "Children's Hospital Center of Akron- NDC- Developmental Pediatrics",
    'AMG Endocrinology',
    'OSU Internal Medicine',
    "Nationwide Children's Hospital Genetics Clinic",
    'Mercy Health - St Elizabeth Boardman Mom and Baby',
    'Mercy Health - North Lima Pediatrics',
    'Licking Memorial Family Practice- Johnstown',
    'Genesis Rheumatology Care Center',
    'Genesis Digestive Disease Specialists',
    'Fairfield Healthcare Professionals Wound Conic',
    'ACHP- Emergency Medicine',
    'Mercy Health - White Oak Primary Care',
    'Aultman Divison of Medical Education',
    'Smith Facial Plastics',
    'ACHP- Surgery',
    'Cleveland Clinic Akron General Alcohol and Drug Recovery Center',
    'Southgate Chiropractic',
    'Mary Ann Flickinger LPCC NCC',
    'Mary Ann Flickinger PCC NCC',
    'Erdey Searcy Eye Group Inc',
    'Mercy Health - Warren Maternal Fetal Medicine',
    "Mercy Health - Boardman Women's Center",
    'Mercy Health - CSMOC Bridgetown',
    'The Mercy Hernia and General Surgery Center',
    "Children's Hospital Center of Akron-Urology",
    "Children's Hospital Center of Akron - ACHP-Twinsburg",
    'Victor Dizon DO FACOS Inc',
    'Genesis Perry County Medical Center',
    'Connie Ball MD LLC',
    'Oakivew Dermatology',
    'Mercy Health - St Elizabeth Youngstown Orthopaedics Inpatient',
    'Mercy Health - Downtown Health Center',
    'Lighthouse Family Chiropractic LLC',
    'Mercy Health - Perrysburg Urology',
    'Mercy Health - Regency Urology',
    'ORR MD Inc dba Muskingum Pediatrics',
    'Meridian Pediatrics',
    'New Life Spine Center',
    'Clinical Care Consultants LLC',
    'Mind Matters Medical LLC',
    'Raymond Chiropractic',
    'ACHP-Perry Township',
    "Children's Hospital Center of Akron- Phycology",
    'ACHP - Rheumatology',
    'Clark Family Practice LLC',
    'Cleveland Clinic Union Hospital Family Medicine Dr Cameron',
    'Scheidler Medical Preferred LLC',
    'Hoover Road Family Practice',
    "Nationwide Children's Hospital Primary Care Center - Olentangy",
    "Nationwide Children's Hospital Primary Care Center-Olentangy",
    'Surgical Oncology Associates of Columbus',
    'AT Tamboli MD Inc',
    'A T Tamboli MD Inc',
    'Sistersville General Medical Clinic',
    'Janet Z Brinn PsyD',
    'Donna Estreicher PHD',
    'Cleveland Clinic Akron General Bariatric Center',
    "Mercy Health - Children's Hospital ENT",
    'Mercy Health - Boardman Rheumatology',
    'Fisher Titus Pain Management',
    'The Letterly Pain Management Center',
    'Samaritan Pain Management',
    'Mercy Health - Breast Surgery Kenwood',
    'Mercy Health - Toledo Physical Medicine and Rehabilitation',
    'Mercy Health - Oregon Physical Medicine & Rehabilitation',
    'Mercy Health - Sylvania Physical Medicine and Rehabilitation',
    'Mercy Health - Defiance Clinic Neurosurgery',
    'Mercy Health - Orthopaedics and Sports Medicine Sardina',
    'School for Createive and Performing Arts',
    'The Childrens Home of Cincinnati  ECS',
    'Mercy Heath - Respiratory Specialists Perrysburg',
    'Mercy Health - Defiance Clinic Pediatric Pulmonary',
    'Mercy Health - Tiffin Specialty Clinic',
    'Mercy Health - Weight Management Solutions West',
    'ACHP - Sleep Medicine',
    'Genesis Palliative Care Specialists',
    'Digestive Associates of Ohio LLC',
    'Amy Gray LLC',
    'Body Mechanic Physical Therapy LLC',
    'Mercy Health - Maineville Primary Care',
    'Elmore Chiropractic',
    'Fairfield Healthcare Professionals Millersport Clinic',
    'Fairfield Healthcare Professionals Orthaepedics',
    'TY & Associates',
    'Mercy Health - Urbana Behavioral Health',
    'Mary Rutan Wound Care Clinic',
    'Columbus Physicians Group LLC',
    'Mercy Health - Center of Excellence',
    'Mercy Health - Cornersburg Primary Care',
    'Mercy Health - Defiance Sleep Clinic',
    'Mercy Health - Respiratory Specialists Oregon',
    'Donnalyn Moeller DPM INC',
    'Mercy Health - Rejuvenation Spa',
    'Genesis Medical Group LLC (Genesis Wound Care Center)',
    'Wards Corner Chiropractic & Sports Rehab',
    'Viewpoint Psychological Services',
    'Chiofalo Chiropractic',
    'Mercy Health - East Palestine General Surgery',
    'Mercy Health - Perrysburg Podiatry',
    'Muskingum Valley Healh Centers',
    'Currence Consulting LLC',
    'Mercy Health - Salem General Surgery',
    'Family Medicine of Stark County',
    'AMG Canton South Medical Center',
    'Barnesville Hospital',
    'Licking Memorial Family Practice Licking Valley',
    'Mercy Health - Avon Primary Care',
    'Mercy Health - General and Laparoscopic Surgery Harrison',
    'Mercy Health - General and Laparoscopic Surgery Westside',
    'Hope 419',
    'Purvis Chiropractic',
    'Advanced Ankle and Foot Center LLC',
    'Mercy Health - CSMOC Fairfield',
    'Fairfield Healthcare Professionals Sleep Medicine',
    'FAIRFIELD HEALTHCARE PROFESSIONALS SLEEP LAB',
    'Fairfield Healthcare Professionals- Diley',
    'ACHP-Massillon',
    'ACHP Sandusky',
    'Mount Carmel Heart & Vascular Specialist',
    'Wheeling Hopsital Inc',
    'Beacon Orthopaedics & Sports Medicine Montgomery',
    'A New Direction For Counseling',
    'Licking Memorial Womens Health-Newark',
    'Ryan Macks LLC',
    'AMG Cancer Center',
    "Mercy Health - St Rita's Pediatric Endocrinology",
    'Mercy Health - Tiffin Cancer Center',
    'Ohio Physician Professional Corporation dba Surgical Associates of Canton',
    "Mercy Health - St Rita's Sleep Center",
    'Cleveland Clinic Union Hospital Urology',
    'Muskingum Medical Group LTD',
    'Bloomberg Eye Center',
    'Boggs Chiropractic',
    'Mercy Health - Infectious Disease West',
    'Mercy Health - Kings Mills Hospital Infectious Disease',
    'ACHP - Surgery',
    'Holzer Clinic LLC -Wound Care',
    'Fairfield Healthcare Professionals Obstetrics and Gynecology',
    'Mercy Health - Perrysburg Family Medicine',
    'Child Focus',
    'Mercy Health - Van Wert Oncology',
    'Mercy Health - Delphos Oncology',
    'Genesis Coshocton Family Practice',
    'Genesis OBGYN Group',
    'Hocking Valley Community Hospital Rural  Health Clinic',
    'Mount Carmel - OSU Physician Alliance',
    'Genesis Crooksville Family Practice',
    'ACHP-Allergy & Immunology',
    'Integrated Dermatology of Columbus LLC',
    'Mercy Health NWOPCP Pemberville Family Medicine',
    'Robert D Berry',
    'Mercy Health - Orthopedics and Sports Medicine',
    'Greene Chiropractic Center',
    'Mercy Health - Deerfield Sleep and Critical Care',
    'Fedorko Chiropractic Health Center',
    'Hilltop Wellness & Chiropractic',
    'Mercy Health - Youngstown Dental Care',
    "Children's Hospital Center of Akron- Infectious Disease",
    'Providence Kidney & Hypertension Specialists LLC',
    'Mercy Health - Perrysburg Great Lakes Gastroenterology',
    'Aultman Medical Group North Canton Medical Center',
    'AMG Family Medicine of Stark County',
    'ACHP -ENT',
    'Buckeye Chiropractic & Wellness',
    'Gallo Eye & Facial Plastic Surgery',
    'Capitol Sleep Medicine LLC',
    'Complete EyeCare West',
    'The Center For Symptom Relief LLC',
    'Mercy Health - East Springfield Internal Medicine',
    'Stouder Chiropractic',
    'Fairfield Nephrology And Hypertension',
    'Aultman Orrville Dunlap Family Physicains',
    'Monina M Jao MD',
    'Mercy Health - The Neuroscience Institute Executive Parkway',
    'Mercy Health - The Neuroscience Institute Port Clinton',
    " The Children's Home of Cincinnati",
    'Central Ohio Breast and Endocrine Surgery',
    'Comprehensive Pain Management Institute LLC',
    'Licking Memorial Pain Management',
    'Mercy Health - Springfield Weight Mgmt & General Surgery',
    'Mercy Health - Horizon Family Medicine',
    'Norton-Kings Daughters Health',
    'FHP First Medical Urgent Care',
    'Mercy Health - Clermont Psychiatry',
    "Children's Hospital Center of Akron- ACHP",
    'Mercy Health - The Neuroscience Institute',
    'Ohio Valley Eye Physicians & Surgeons PLLC',
    'Mercy Health - Defiance Clinic Neurology',
    'General Surgical Associates Inc',
    'Mercy Health - Adams County Family Medicine',
    'Columbus Womens Care Inc',
    'Holzer Clinic LLC - Chiropractic',
    'Mercy Health - St Anne H&P Services',
    'Mount Carmel Infectious Disease Specialists',
    'Physical Medicine Associates Inc',
    'Hillman H Hum MD',
    'John M Smilo DPM',
    'Mercy Health - Lorain Family Health Center',
    'Mercy Health - Clinton Street Family Medicine',
    'Mercy Health - Oregon Walk-in Care',
    "Children's Hospital Center of Akron- Mansfield",
    'Akron General Childrens- Emergency',
    'Heart of Ohio Pediatrics LLC',
    'Mercy Health - Behavioral Health Addiction Services',
    'Mercy Health - Behavioral Health Institute Warren',
    'Holzer Clinic LLC - Allergy & Immunology',
    'Bloom Family Eye Surgeons',
    'Licking Memorial Surigcal Services',
    'Zanesville-Muskingum County Health Department',
    'Precision Orthopaedics Specialties',
    'David Perlaki DBA Heartmender Counseling Center',
    'Mercy Health - Heart & Vascular Institute Lambertville',
    'ACHP-Warren',
    'Life Support Therapy Services LLC',
    'Licking Memorial Pediatrics- Pataskala',
    'Holzer Clinic LLC - Nephrology',
    'Aultman Family Medicine Waynesburg Family Medicine',
    "Nationwide Children's Hospital Cleft Palate/Cranio Facial Cl",
    'Mercy Health - Milford Family Medicine Suite 103',
    'Mercy Health - Breast Surgery West',
    'Joseph Kennell PhD',
    'Long Chiropractic Office',
    'Diseases of the Ears Nose & Throat Inc',
    'Laura Nabors PhD',
    'Scoggan Counseling LLC',
    'Mercy Health - Springdale Psychology',
    'A2R Counseling and Consulting LLC',
    'Genesis Center of Surgical Excellence',
    'Mercy Health Psych - Maumee',
    'Miller Psychiatric Services LLC',
    'Mercy Health - Maumee Primary Care',
    'Mercy Health - General and Laparoscopic Surgery Clermont',
    'Trust Medical Services Inc',
    'OHIO HOSPITAL-BASED PHYSICIANS CORPORATION',
    'Changing Minds LLC',
    'Mercy Health - General Laparoscopic Surgery Adams County',
    'Che-Fu Kuo MD PhD',
    'A New Direction for Counseling LLC',
    'Tarun Mehra MD Inc',
    'Diley Ridge',
    'AMG Gynecologic Oncology',
    'Hamilton Health Associates',
    'Licking Memorial Pulmonology and Sleep Medicine',
    'Coshocton Regional Medical Center Pulmonary Services',
    'Mercy Health - Endo Cholesterol and Diabetes Amberly',
    'Mercy Health - St Charles Infectious Disease',
    'Mercy Health - Oregon Infectious Disease',
    'Gateways Recovery',
    'Mercy Health - Greenwich Family Medicine',
    'Genesis Foot & Ankle',
    'Licking Memorial Dermatology',
    'NEPHROLOGY CONSULTANTS OF SEO',
    'Nephrology Consultants of SEO Inc',
    'Center for Personal Empowerment',
    "Mercy Health - St Rita's Obstetrics and Gynecology",
    'Juszczyk Chiropractic Inc',
    'Nephrology Consultants',
    'Mercy Health - Lorain Hospital Hyperbaric Medicine',
    "Children's Hospital Center of Akron - NDC Developmentental Pediatrics",
    'Premier MD',
    'Dunlap Family Physicians of AMG',
    'ACHP - Partial Hosp',
    'Pain Management Group - Bellevue Hospital',
    'Aultman House Call',
    'Mercy Health - Delhi Primary Care',
    'Mercy Health - Sayler Park School Health Center',
    'OSU Health System Neurosurgery',
    'Mercy Health - Willard Obstetrics and Gynecology',
    'Leaf Chiropractic: A Creating Wellness Center',
    'Jeffries Chiropractic and Wellness',
    'Richard Gaynor PhD',
    ' FAMILY ALLERGY & ASTHMA',
    'Cambridge Chiropractic Health Center LLC',
    'Lancaster Hematology Oncology',
    'New Day Therapy LLC',
    'Mercy Health - Youngstown Interventional Radiology',
    'OSU Neuro-Psychiatric Physician',
    'Mercy Health - Mt Washington School Health Center',
    'Mercy Health - Georgetown Family Medicine',
    'Mercy Health - Clermont Northeastern School Center',
    'Mercy Health - Little Miami School Health Center',
    'Mercy Health - St Charles Pain Medicine',
    'Heidi Nunemaker LPCC-S',
    'Emergency Medicine',
    'Kidney & Hypertension Specialists of Jackson Piketon & Chillicothe LLC',
    'Feldkamp Chiropractic Clinic',
    'Ohio Hills Health Center Barnesville',
    'Ohio Hills Health Center Freeport',
    'Ohio Hills Health Center Quaker City',
    'Ohio Hills Health Center Caldwell',
    'Ohio Hills Health Center Woodsfield',
    'Well Balanced Chiropractic',
    ' Heights Chiropractic Physicians',
    'Mercy Health - Willard General Surgeons',
    'Northridge Family Practice LLC',
    'Mercy Health - The Heart Institute Hamilton',
    'Sarah M Teague DC',
    'John Antalis MD',
    'Booth Chiropractic',
    'Neuro Spine & Wellness Center',
    'Varckette Family Chiropractic',
    'Mercy Health - Defiance Clinic Pediatric Cardiology',
    'Welcome Nursing Home',
    'Licking Memorial Family Practice Pataskala',
    'Mount Carmel Medical Group Worthington',
    "Aultman Medical Group Women's Health Services",
    "AMG Women's Health Services",
    'AMG Womens Health Services',
    'Fairfield Healthcare Professionals Gastroentrology',
    'Holzer Clinic LLC - Interventional Radiology',
    "Nationwide Children's Hospital Family Development Clinic",
    'Mercy Health - Avon Neurology',
    'Mercy Health - Sheffield Neurology',
    'Roehnell J Drue',
    'Mercy Health - Howland Pulmonary Medicine',
    'Perry Spine & Wellness Center',
    'Holistic Family Chiropractic',
    'Warren County Combined Health District',
    'Newark-Granville Psychological and Counseling Services Ltd',
    'Ohio Ophthalmology Inc',
    'Summit Urogynecology',
    'Mercy Health - Colorectal Surgery Mason',
    'Mercy Health - Colorectal Surgery Eastgate',
    'Saling Chiropractic Hand Foot & Spine',
    'Licking Memorial Pediatrics-East',
    'Newark Granville Psychologicial and Counseling Services Inc',
    'Counseling & Wellness Center OH',
    'Worthington Optimal Wellness',
    'Worthington Optimal Wellness / Worthington Chiropractic Center',
    'Licking Memorial Orthopedic Surgery',
    'Serenity Counseling for All Ages Inc',
    "Nationwide Children's Hospital Cerebral Palsy Clinic",
    'ValleyGastroenterology & Endoscopy',
    'Valley Gastroenterology &  Endoscopy',
    'OSU Pathology LLC',
    'Marilyn K Kosier MD Inc',
    'Akron Childrens Hospital -Specialty Care Amherst',
    'ACHP - LakeHealth TriPoint',
    'Mercy Health - Loveland Primary Care',
    'Union Physician Services LLC',
    'Mercy Health Psych - Horizons',
    'Mercy Health Psych - Perrysburg',
    'Mercy Health Psych – Starbright',
    'Mercy Health Psych - Bay Meadows',
    'Mercy Health Psych - Sunforest',
    'Licking Memorial Family Practice - Granville',
    'Mercy Health - Springfield Neurology',
    'Holzer Clinic LLC - Oncology',
    'Mercy Health - Kenwood Vascular Surgery',
    'Mercy Health - Wound Care The Jewish Hospital',
    'Broeg Chiropractic & Nutrition Center',
    'Kirk Chiropractic',
    'Northwest Ophthalmology Center Inc',
    'Mercy Health - Tri County Primary Care',
    'Saba A Chughtai LLC',
    'Mercy Health - Springfield Physical Medicine & Rehab',
    'Fairfield Healthcare Professionals - Family Medicine of Amanda',
    'EORH Physician Group LLC',
    'Wheeling Hospital Inc Center for Pediatrics',
    'Orthopedic Institute of Dayton',
    'Licking Memorial Pulmonololgy',
    'Ohio Valley Eye Physicians &amp; Surgeons PLLC',
    'Ohio Valley Eye Physicians PLLC',
    "Licking Memorial Women's Health-North Newark",
    'Licking Memorial Inpatient Medical Specialists',
    'Columbus Kidney Care',
    'Central Ohio Nephrology & Hypertension Clinic',
    'The Childrens Home of Cincinnati Three Rivers School',
    'Southeastern Ohio Counseling Center',
    "Mercy Health - Women's Care at Kenwood Towne Centre",
    'Mercy Health - Ohio Northern University Health Center',
    'Mercy Health - Osteoprosis and Bone Health Services Kenwood',
    "Mercy Health - St Rita's Pulmonary - Celina",
    'St John Medical Center',
    'Chiropractic Associates of Zanesville',
    'Aryeh Gorenstein MD Inc',
    'Ankle & Foot Associates',
    'On Site Dermatology LLC',
    'Diagnostic Referrals-Akron',
    'OSU Observation LLC',
    'Fairfield Healthcare Professionals First Medical Urgent Care',
    'Mount Carmel Pain Management',
    'Hopwell Health Centers Inc',
    'Bressler & Schaeffer Inc',
    'Reser Chiropractic Inc',
    'Mercy Health - South Limestone Family Medicine',
    'Mercy Health - Liberty Falls Pulmonary and Critical Care',
    'Mercy Health - Plastic and Reconstructive Surgery West',
    'Mercy Health - Plastic and Reconstructive Surgery',
    'Mercy Health - Plastic and Reconstructive Surgery Deerfield',
    'Mercy Health - Anderson Plastics and Reconstructive Surgery',
    'Mercy Health - Columbiana Gastroenterology and Hepatology',
    'Licking Memorial Infectious Disease',
    'Clark Family Practice',
    'Mercy Health - Recovery Services',
    'ACHP - Libson',
    'Mercy Health - Struthers General Surgery',
    'Family Allergy and Asthma',
    'Aultman Cancer Center of Alliance',
    'Denham Medical Clinic PSC',
    'Neel Raya MD Inc',
    'Mercy Health - Defiance Clinic Pain Management',
    'Mercy Health - Napoleon Clinic Pain Management',
    'Mercy Health - Lorain Colorectal and General Surgery',
    'Mercy Health - Sheffield  Colon and Rectal Surgery',
    'Michael Wagner PHD',
    'Sidney Chiropractic',
    'Integrated Heath Center dba Granville Chiropractic LLC',
    'The Counseling Cottage',
    'Ohio Specialty Physician Corporation',
    'Mercy Health - Fairfield Pulmonology Sleep & Critical Care',
    'Sol Therapy LLC',
    'Family Chiropractic Clinic',
    'Holzer Clinic LLC - Pulmonary Disease',
    'Stephen R Stanley DO Inc',
    'Mahyar Tahbaz DO',
    "Mercy Health - St Rita's Cardiology Pacer Clinic",
    'Center for Personal Empowerment LLC',
    'Fairfield Health Care Professionals',
    'Fairfield Healthcare Professionals Diley',
    "Children's Hospital Center of Akron - Diagnostic Referrals",
    'Dr Mirodrag Zivic LLC',
    'Fairfield Healthcare Professionals Old Schoolhouse Family Practice',
    'Genesis Medical Group/Genesis Breast Care Center',
    'Mercy Health - Niles Primary Care',
    'Ohio Family Counseling and Consultation LLC',
    'Pediatric Pathology Associates of Columbus Inc',
    'Mercy Health - Oberlin Breast Surgery',
    'Mercy Health - Sheffield Breast Surgery',
    'Steven D Kapetansky MD',
    "Nationwide Children's Center for Autism Spectrum Disorders",
    "Children's Hospital Center of Akron-Gastroenterology",
    'ACH - Gastroenterology',
    'Mercy Health - General and Laparoscopic Surgery Kings Mills',
    'Fairfield Healthcare Professionals Pulmonary/ Critical Care',
    ' ACHP - Gastroenterology',
    'EORH Physicians-East Ohio Hospital LLC',
    'Granville Chiropractic LLC',
    'Genesis First Care',
    'Mercy Health - Perrysburg Palliative Care',
    'Mercy Health - Palliative Care',
    'Counseling and Wellness Center OH',
    'Mercy Health - Dermatology Kenwood',
    'Akron General Orthopedics',
    'Mercy Health - Avon Endocrinology',
    'Mercy Health - Sheffield Endocrinology',
    'Nancy Stella PhD PsyD LLC',
    'Aultman North Canton Medical Group - Canton South Medical Group',
    'Mercy Health - St Vincent Maternal Fetal Medicine',
    'Kidney & Hypertension Center of Delaware LLC',
    'Senter Counseling Services LLC',
    'Aultman Breast Surgery',
    'Hocking Valley Community Hospital',
    'Mercy Health - Vienna Primary Care',
    'Genesis Primary Care Physcians LLC',
    'Mercy Health - Clermont Gastroenterology',
    'Mercy Health - Anderson Gastroenterology',
    'Mercy Health - Oberlin Obstetrics and Gynecology',
    'Ohio Vascular Surgery Inc',
    'Mercy Health - North Lima Physical Therapy',
    'Oak Hills Back and Neck Care Center LLC',
    'Mercy Health - Northwest Advanced Cardiology',
    'James W McNeilis MD LLC',
    'A Johnson Mental Health Services LLC',
    'Cleveland Clinic Health Services Professional Association Inc',
    'Mercy Health - Neurology Clermont',
    'Genesis Womens Health Specialists',
    'Kinect Rehab',
    'La Femme OB/GYN  LLC',
    'Mercy Health - St Anne Post Acute Care',
    'Mercy Health -Tiffin Hospital Pulmonary Outreach',
    'Shaffer Chiropractic',
    'Medical Associates of Zanesville Ltd',
    'Central Ohio Medical Management LLC',
    'Southern Local Schools Wellness Center',
    'ACHP - Diagnostic Referrals-Mansfiled',
    'Mercy Health - St Anne Cancer Center',
    'SABA A CHUGHTAI MD and ASSOCIATES',
    'Mercy Health - Springfield Family Practice',
    'Angelo N Georges MD',
    'Podiatric Medical Specialists',
    'Jack Neggerman MSSW',
    'Fairfield Healthcare Professionals Old Schoolhouse Family',
    'Fairfield Healthcare Professional Internal Medicine Residency',
    'Frame Chiropractic and Acupuncture',
    'Pamela G Parker LISW',
    'Schiffler Cancer Center of Wheeling Hospital',
    'Mercy Health - Tiffin Wound Care',
    'Mercy Health - Tiffin Podiatry Clinic',
    "Mercy Health - St Rita's Hospice",
    'Eyman Chiropractic',
    'ACH Obstetrics & Gynecology',
    'CCF New York Medical Services PC',
    'Fairfield Healthcare Professionals New Lexington Primary Care',
    'Jeffrey J Haggenjos DO Inc',
    'Mid Ohio Behavioral Health LLC Unit #4',
    'Mercy Health - Oak Point Primary and Specialty Care',
    'Levinson Family Chiropractic',
    'Mercy Health - Lorain Thoracic Surgery',
    "Licking Memorial Women's Health - Pataskala",
    "Licking Memorial Women's Health - Granville",
    "Licking Memorial Women's Health - Newark",
    "Licking Memorial Women's Health - Downtown",
    'Abraham Mikalov MD',
    'Heights Chiropractic Physicians',
    'Southeastern Ohio Counseling LLC',
    'ACH Neonatology',
    'Aultman Medical Group Richard Jones MD',
    'Ohio Physician Professional Corporation',
    'Mercy Health - North Lima Orthopedics',
    'Fairfield Healthcare Professionals Pre-Admission Screening Center',
    'FHP SASU Medical Practice',
    'Mount Carmel Medical Group Reynoldsburg',
    'Advanced Health and Wellness Center of Ohio LLc dba Brecksville Physical Medicine',
    '2050 Kenny Rd 9th Fl',
    'Quality Care Associates Urgent Care and Wellness Center LLC',
    'Mercy Health - Parkman Primary Care',
    'Norton - Kings Daughters Health Inc',
    'Mercy Health - Wapak Plastic Surgery',
    'Mercy Health - Lima Reconstructive & Plastic Surgery',
    'Family Practice Clinic',
    'Mercy Health - CSMOC Kenwood',
    'Mercy Health - Infectious Disease Anderson Hospital',
    'Mercy Health - Infectious Disease Anderson',
    'Mercy Health - West Chester Primary Care and Pediatrics',
    'Marietta Memorial Hospital Wound Care Center',
    'Mercy Health-White Oak Primary Care',
    "Akron Children's Hospital - Diagnostic Referrals-Youngstown",
    'Licking Memorial Would Clinic',
    'Freeport Family Medical Center',
    'Caldwell Family Practice Center',
    'OSU Hospitals Occupational Medicine',
    'Mercy Health  - Southwest Schools Community Health Center',
    'Mercy Health - Springdale Family Medicine Liberty Falls',
    'ACHP - Pediatric Medicine-Locust Pediatric Care Group',
    'Worthington Ophthalmology Inc',
    'Mercy Health - West Hospital Based Provider',
    'Allison Smith LPCC',
    'Mercy Health - Mt Orab Psychology',
    'Mercy Health - Kings Mills Ear Nose and Throat',
    'Mercy Health-Heart and Vascular Institute Sheffield Village',
    'Mercy Health - Heart and Vascular Oak Point',
    'Mount Carmel Care Today',
    'DR MIODRAG ZIVIC  MD LLC',
    'DR MIODRAG ZIVIC MD LLC',
    'Licking Memorial Family Practice- Tamarack',
    'Ohio Ear Institute LLC',
    "Mercy Health-St Rita's Neuroscience and Rehab-Bellefontaine",
    'Mercy Health – Putnam Pain Management',
    'Cleveland Clinic Akron General Primary Care Lodi',
    'Beckett Springs Physician Group',
    "Altens Women's Health LLC",
    'Central Ohio Plastic Surgery Inc',
    'Mercy Health - Glandorf Flu Clinic',
    'Mary Rutan Proctology',
    'Mary Rutan Hospital-Pulmonology',
    'Ohio Plastic Surgery Specialists',
    'Aultman Primary Care',
    'AMG Mansard Medical',
    'Advanced Spine Rehab & Athletics',
    'Tracey Childress FNP-BC',
    'William Bauer LPC',
    'Clinic Akron General Geriatrics',
    'Aultman Medical Group Steven Weaver MD',
    'Mercy Health - St Elizabeth Youngstown Wound Care Center',
    'Mercy Health - St Joseph Warren Wound Care Center',
    'Mercy Health - St Elizabeth Boardman Wound Care Center',
    'ACHP - Speciality Care Nursery',
    "Nationwide Children's Hospital Myelomeningocele Clinic",
    'Mercy Health - St Elizabeth Boardman Hospital Pain Medicine',
    'Aultman General Surgery 620',
    'Axis Spine Clinic LLC',
    'Restor Metabolix Columbus',
    'Zanesville Medical Center',
    'Genesis Primary Care Physicicans LLC',
    'Counseling & Wellness Center Ohio LLC',
    'Taylor Station Surgical Center',
    'Holzer Clinic LLC - Orthopedics',
    'Aultman Hospital Weight Management',
    'Mercy Health - Sylvania Radiation Oncology',
    'Baltimore Chiropractic Clinic',
    "Licking Memorial Women's Health-Granville",
    'Genesis Primiary Care Physicians LLC',
    'Sprandel Chiropractic Clinic',
    'Mercy Health - Amberley Village Gynecology',
    'Zanesville Family Practice Inc',
    'Fairfield Health Care Professionals Gastroenterology',
    'Georgette  Comisar Inc',
    "Children's Hospital Center of Akron- Adolescent Medicine",
    'Mercy Health - Endo Cholesterol and Diabetes Montfort Hght',
    'Mercy Health - Youngstown Physical Medicine and Rehab',
    'Mercy Health - Eastgate OB/GYN',
    'Aultman Medical Group Canton South Medical Center',
    'Mercy Health - Urbana Obstetrics and Gynecology',
    'Fairfield Healthcare Professionals Specialties of Logan',
    'Fairfield Healthcare Professionals Specialty of New Lexington',
    'Mercy Health - Lima Triage Clinic',
    'Five Point Chiropractic',
    'Mercy Health - St Vincent Vascular Lab',
    'American Health Network - Delaware Family Medicine',
    'Marietta Health & Wellness',
    'Rinehart Chiropracti Clinic',
    'Mana Medical Inc',
    'Beacon Orhtopaedics & Sports Medicine',
    'N8 Family Chiropractic of Lancaster',
    'Pediatric Ophthalmology Associates Inc',
    'Regional Cardiac Arrhythmia',
    'AMG Family Medicine of Massillon',
    'Aultman Medical Group Family Medicine of Massillon',
    'Marietta HealthCare Physicians Inc',
    'Lawrence P Wang MD LLC',
    'Cates Chiropractic',
    'Family Medical Care Plus Inc',
    'BARNESVILLE SURGERY INC',
    'Elizabeth Leslie - Leshner',
    'Aultman Alliance Hematology & Oncology',
    "Children's Hospital Center of Akron - Developmental Pediatrics",
    'Mount Carmel Central Ohio Neurological Surgeons',
    'Norton Kings Daughters Health Inc',
    'Apex Spine and Performance',
    'Cain Chiropractic',
    'Ohio Psychiatric Associates',
    'Katharine Schulz PhD',
    'Chiropractic Health & Wellness Center',
    'Holzer Clinic LLC - Ophthalmology',
    'American Health Network',
    'Swiss Valley Foot & Ankle Center',
    'Mercy Health - Infectious Disease Forest Park',
    'Mercy Health - Infectious Disease Fairfield',
    'ACHP Ophthalmology',
    'Lake Clinic',
    'Aultman Deuble Hear & Vascular Hospital LLC',
    'Radiant Star Counseling Services LLC',
    'Serenity Grace Counseling',
    'Mercy Health - Endo Cholesterol and Diabetes Avondale',
    'Apex Spine & Performance',
    'Mercy Health - Pleasant Hill Academy Health Center',
    'Beacon Orrthopaedics & Sports Medicine',
    'Aultman Dueble Heart & Vascular Hospital LLC',
    'Mercy Health - Boardman Wound Care Center',
    'Kathleen A Grant PSYD',
    'Mercy Health - Boardman Walk-In Care',
    'Marietta Mememorial Hospital',
    'Mary Rutan Hospital-Endocrinology',
    'Aultman Alliance Hospital',
    "Nationwide Children's Hospital Developmental Behavioral Pediatrics",
    'Eye Care & Surgery Assoc INC',
    'Fairfield Healthcare Professionals Infectious Disease',
    'Mercy Health - Dry Ridge Psychology',
    'Amy Brenner MD and Associates LLC',
    'Mercy Health - Willard Oncology',
    'Coshocton County Foot and Ankle Center Inc',
    "Aultman Women's Health Services",
    'Integrity Wound Care LLC',
    'Vernon Williams Md LLC',
    "Children's Hospital Center of Akron - ACHP-Wooster",
    ' Family and Sport Chiropractic LLC',
    'Aultman Orville Dunlap Family Physicians',
    'Elevate Chiropractic',
    "Nationwide Children's Hospital Livingston Ambulatory Center",
    'Joint Implant Surgeons PT',
    'Marietta Memorial Hopsital',
    'Cleveland Clinic Akron General Traumatic Brain Injury Clinic',
    'Progressive Health & Rehab Corp',
    'Brian Barkett PsyD LLC dba Better Minds Group LLC',
    'Medical Home Primary Care',
    "Akron Children's Hudson",
    'Malkoff & Assoc Psych Services',
    'Mount Auburn Nephrology Inc',
    'Childrens Hospital Center of Akron- Heart Center',
    'Priority Medical Family Practice LLC',
    'Amy Untied LLC',
    'Mercy Health-Vienna Primary Care',
    'Aultman Urology',
    'Hygge Behavioral Health and Wellness LLC',
    'Mary Rutan Urology',
    'ACHP NDC-Neurology',
    'Douglas A Katula LLC',
    'Orthopedic Specialists & Sports Medicine',
    'Twila Pike CNS',
    'Wooster Chiropractic Clinic',
    'Debbie E Dickson Counseling Inc',
    'Coshocton Regional Medical Center Family Physicians Clinic',
    'Ohio Gastroenterology Group',
    'Diagnostic Referrals-Warren',
    'Mercy Health - Defiance Clinic Bariatric Surgery',
    'Mercy Health - Oregon Bariatric',
    'Eric Mersch DC LLC',
    'GPC Womens Health-Tuscarawaras County',
    "Nationwide Children's Hospital Pharmacology/Toxicology Clini",
    "Nationwide Children's Hospital Pharmacology/Toxicology Clinic",
    'Garabis Family Medicine LLC',
    'James J Sardo MD Inc',
    'Fairfield Healthcare Professionals Inc',
    'Paulding County Pain Management',
    'New Day Pain Management Center',
    'Van Wert Health Pain Management Center',
    'Van Wert Health Pain Management',
    'Loveland Chiropractic Office'
  ],
  [ValidStates.AZ]: [
    'Cardiovascular Associates of Mesa, PC',
    'Sameer Chopra MD PLLC',
    'Arizona Kids Pediatrics Ltd',
    'Cardiac Solutions - Peoria',
    'Cardiac Solutions',
    'Sole Foot and Ankle Specialists PC',
    'Healthfinity, PLLC',
    'Sammy A Zakhary, MD, PC',
    'Cameron RIA, LLC',
    'Valley Surgical Clinics, Ltd.',
    'Arbor Medical Partners, LLC',
    'Maricopa Ear, Nose and Throat, P.C.',
    'Southwest Gastroenterology, LLC',
    'Estrella Ear, Nose and Throat, PC',
    'Arcadia Foot and Ankle PC',
    'The Foot',
    'Gerard B. Chamberlin, MD, MPH, PC',
    'Saguaro Foot & Ankle Clinic, PLLC',
    'Goodyear Eye Specialists',
    'Aprajita Nakra, DPM, P.C.',
    'Healing Horizons Psychiatry',
    'William L. Weiss, MD PC',
    'Serve MD LLC',
    'Tesai, PLC',
    'AZ Orthopedics, LLC',
    'Pioneer Cardiovascular Consultants, PC',
    'Pioneer Cardiovascular Consultants PC',
    'The Insomnia and Sleep Institute of Arizona, LLC',
    "Children's Oasis Pediatrics",
    'Desert Foot & Ankle, PC',
    'Sahai Surgical Specialists, PLC',
    'San Tan Allergy & Asthma',
    'Arizona Retina and Vitreous Consultants, LLC',
    'Pelvic Medicine & Reconstructive Surgery, LLC',
    'Sam P Smith DO LLC',
    'Cardiovascular Clinic of Arizona, PLLC',
    'Desert Kidney Associates, PLC',
    'Wesley Community Center',
    'Endocrinology Diabetes & Thyroid Center of Arizona, PLLC',
    'Khera Cardiology Center, P.C.',
    'All Family Care, PC',
    'Allergy Asthma Clinic, Ltd.',
    'Arizona Allergy Associates, PLC',
    'Acute Care Surgical Specialists',
    'K.D. Keel, PLLC',
    'Az Endocrine Institute, PC',
    'Edgar Bekteshi, MD, PLLC',
    'Desert Sky Urology PLC',
    'East Valley Dermatology Center, PC',
    'Ronald I Jones MD PC',
    'Gregg Krahn, DPM, PC',
    'Grand Canyon Family Medicine PC',
    'Kyrene Internal Medicine PLLC',
    'Sun State Cardiology PC',
    'Desert Behavioral Health, PC',
    'Heelex 2 LLC',
    'Arizona Minimally Invasive Sinus Institute PLLC',
    'Central Arizona Pain Institute',
    'Kathleen J. Richards, DPM',
    'Phoenix Skin II, PC',
    'Arora Eye, PLLC',
    'Arizona Heart Doctor, PLLC',
    'Arizona Foot and Ankle Physicians PLLC',
    'Ben Ora Hansen & Vanesian Imaging Ltd.',
    'The Center for Pain and Supportive Care, PLLC',
    'JDOC, LLC',
    'Endocrinology Associates PA',
    'Advanced Retina and Eye Cancer Center, LLC',
    "North Scottsdale Women's Care",
    'Neurology Consultants of Arizona LLC',
    'Arizona Medical Group, LLC',
    'Carefree Internal Medicine, PC',
    'Ocotillo Primary Care, LLC',
    'Sunrise Pediatrics',
    'Avant Dermatology & Aesthetics, PLLC',
    'Hera Health Medical Group - AZ PLLC',
    'Healthfirst Primary Care, PLLC',
    'Patterson Schlotterer Medical Group',
    'Phoenix Ophthalmologists, P.A.',
    'Kids and Family Kare',
    'Florin Gaidici MD, PC',
    'Healthy Wings LLC',
    'Simmons Foot and Ankle PLLC',
    'Arizona Arthritis & Rheumatology Associates, PC',
    'Allergy Associates of Tucson PC',
    'Phoenician Pain & Rehablilitaion Center, LLC',
    'Eye Consultants and Surgeons of Arizona LLC',
    'TMCOne Rincon',
    'TMCOne Pulmonology Associates',
    'TMC Medical Network',
    'TMCOne Erickson',
    'TMC Integrative Pain Clinic',
    'EMPACT-Suicide Prevention Center',
    'TMCOne La Canada',
    'TMCOne Beverly',
    'TMCOne Skyline',
    'TMCOne Oracle',
    'TMCOne Rincon OB/GYN',
    'TMC Urgent Care Wyatt',
    'TMCOne Wilmot Pediatrics Multi-Specialty',
    'Smriti Rana, MD, PLLC',
    'TMCOne Rita I',
    'TMCOne Wyatt',
    'TMCOne Knight',
    'Bates Family Practice, PLC',
    'TMC Wound Care Center',
    'TMCOne Copperstate OB/GYN',
    'Central Arizona GI & Liver Ins',
    'HealthyU Family Medicine, LLC',
    'Foot & Ankle Specialists of Arizona',
    'Canyon Family Medicine',
    'TMCOne Wilmot Adult Multispecialty',
    'TMCOne Clara Vista Pediatrics',
    'TMCOne- Northwest NeuroSpecialists',
    'Arizona Mohs Surgery, PLLC',
    'Intergrated Physical Therapy, Inc.',
    'EMPACT - Suicide Prevention Center',
    'TMCOne Harrison',
    'TMCOne Endocrinology',
    'Ravi Gupta, MD, PLLC',
    'TMC Urgent Care Rincon',
    'Surraj Medical Associates, PLLC',
    'TMCOne Rincon Multispecialty',
    'IM Specialist, Inc.',
    'Reddy GI Associates, PLLC  DBA: AZ Gastro Care',
    'La Frontera Center - Casa de Vida',
    'La Frontera Center - East Clinic',
    'La Frontera Center - Hope Center',
    'La Frontera Center - Mountain Clinic',
    'La Frontera Center - South Tucson Clinic',
    'La Frontera Center - Southwest Clinic',
    'La Frontera Center Menninger House',
    'La Frontera Center Mountain Rose',
    'La Frontera Center-Thornydale',
    'La Frontera Psychiatric Health Facility',
    'All4Kidz Pediatrics',
    'Ohana Kids & Family Kare LLC',
    'Arizona Clinic, PLLC',
    'Southwest Cardiovascular Associates',
    'Paper Cranes Healthcare, LLC',
    'WKK2Med, PLLC',
    'TMCOne Rita III',
    'Rupal Mohan PC',
    'Central Phoenix Family Medicine, PLC',
    'Cornea & Cataract Consultants of AZ, PC',
    'Shifren Physical Therapy',
    'Southwellness Medical, LLC',
    'TMC Health Oncology- Silverbell',
    'Integrity Pain & Anesthesia PLLC'
  ]
}

export { HospitalsAffiliations, MedicalGroupsAffiliations }
